(() => {
  "use strict";

  // Critical: kill giant lazy-load rings ASAP (before deferred body work).
  (function injectCriticalStorefrontSpeedCss() {
    if (document.getElementById("yb-storefront-speed-style")) return;
    const style = document.createElement("style");
    style.id = "yb-storefront-speed-style";
    style.textContent =
      "html body.show_image_loading .adaptive_height img.lazyload+.data-lazy-loading," +
      "html body.show_image_loading .adaptive_height img.lazyloading+.data-lazy-loading," +
      "html body.show_image_loading .adaptive_height img.lazyloaded+.data-lazy-loading," +
      "html body.show_image_loading .media img.lazyloading+.data-lazy-loading," +
      "html body.show_image_loading .card-media img.lazyloading+.data-lazy-loading," +
      "html body .data-lazy-loading,.data-lazy-loading,.loadingOverlay,.media-loading{display:none!important;" +
      "visibility:hidden!important;opacity:0!important;width:0!important;height:0!important;border:0!important;" +
      "border-radius:0!important;background:none!important;animation:none!important;pointer-events:none!important}" +
      "body.show_image_loading img.lazyload,body.show_image_loading img.lazyloading,body.show_image_loading img.lazyloaded," +
      ".adaptive_height img,.media img,.card-media>img:first-child{opacity:1!important}" +
      "html body.show_image_loading .card-media>img+img,html body.show_image_loading .card-media>img+video," +
      "html body .card-media>img+img,html body .card-media>img+video{opacity:0!important}" +
      "html body.show_image_loading .card-product:hover .card-media.media--hover-effect>img:first-child:not(:only-child)," +
      "html body .card-product:hover .card-media.media--hover-effect>img:first-child:not(:only-child){opacity:0!important}" +
      "html body.show_image_loading .card-product:hover .card-media.media--hover-effect>img+img," +
      "html body .card-product:hover .card-media.media--hover-effect>img+img{opacity:1!important}";
    (document.head || document.documentElement).appendChild(style);
  })();

  if (window.YamBabaProductPageVersion === "20260925vb7") return;
  // Block older duplicate theme/portal copies from clobbering this build.
  window.YamBabaProductPage = true;
  window.YamBabaProductPageVersion = "20260925vb7";
  window.__ybPdpMobileGalleryDomFixed = true;
  window.__ybPdpSafeMarginsVb7 = true;
  if (!/\/products\//i.test(location.pathname)) return;

  (function ensurePdpPolishCss() {
    /* Theme liquid loads polish via Shopify CDN — never rewrite to portal. */
    if (document.querySelector('link[href*="yambaba-ui-polish.css"]')) return;
    const href =
      (window.__YB_THEME_ASSETS__ && window.__YB_THEME_ASSETS__.polish) || null;
    if (!href) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.media = "all";
    (document.head || document.documentElement).appendChild(link);
  })();

  (function injectCriticalPdpThumbCss() {
    if (document.getElementById("yb-pdp-thumb-critical")) return;
    const style = document.createElement("style");
    style.id = "yb-pdp-thumb-critical";
    style.textContent =
      /* Desktop thumb polish */
      "@media (min-width: 768px){" +
      ".yb-pdp-gallery-polish .productView-thumbnail-wrapper .slick-track{display:block!important;flex-wrap:nowrap!important}" +
      ".yb-pdp-gallery-polish.yb-pdp-thumbs-few .productView-for.slick-initialized .slick-slide," +
      ".yb-pdp-gallery-polish .productView-for.slick-initialized .slick-slide," +
      ".yb-pdp-gallery-polish .productView-thumbnail," +
      ".yb-pdp-gallery-polish .productView-thumbnail-link{width:144px!important;min-width:144px!important;max-width:144px!important;height:144px!important;display:block!important;visibility:visible!important}" +
      ".yb-pdp-gallery-polish.yb-pdp-thumbs-few .productView-for.slick-initialized .slick-slide{display:block!important;opacity:1!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link{padding:0!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link::after{display:none!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link img{position:static!important;transform:none!important;width:100%!important;height:100%!important;object-fit:cover!important}" +
      "}" +
      /* Mobile: single-column PDP, contain gallery, usable taps — no body overflow-x hack */
      "@media (max-width: 767px){" +
      ".productView," +
      ".productView-container," +
      ".productView-top," +
      ".productView-top.yb-pdp-3col-row," +
      ".productView-images," +
      ".yb-pdp-gallery," +
      ".productView-details," +
      ".yb-pdp-main," +
      ".yb-pdp-info," +
      ".yb-pdp-buybox{" +
      "width:100%!important;max-width:100%!important;min-width:0!important;" +
      "float:none!important;box-sizing:border-box!important}" +
      ".productView-top," +
      ".productView-top.yb-pdp-3col-row{" +
      "display:flex!important;flex-direction:column!important;gap:12px!important}" +
      ".productView-images," +
      ".yb-pdp-gallery{" +
      "order:1!important;padding-left:0!important;padding-right:0!important}" +
      ".yb-pdp-main," +
      ".yb-pdp-info," +
      ".productView-top.yb-pdp-3col-row > .productView-details," +
      ".productView-details.yb-pdp-details-shell{" +
      "order:2!important}" +
      ".yb-pdp-buybox," +
      ".productView-top.yb-pdp-3col-row > .yb-pdp-buybox{" +
      "order:3!important}" +
      ".productView-nav," +
      ".productView-nav.slick-initialized," +
      "[data-image-gallery-main]{" +
      "width:100%!important;max-width:100%!important;overflow:hidden!important}" +
      ".productView-nav .slick-list{" +
      "overflow:hidden!important;width:100%!important;max-width:100%!important}" +
      ".productView-nav .slick-track{" +
      "display:flex!important;align-items:stretch!important}" +
      ".productView-nav .slick-slide{" +
      "box-sizing:border-box!important;float:none!important}" +
      ".productView-nav .slick-slide:not(.slick-active){" +
      "pointer-events:none}" +
      ".productView-nav .productView-image," +
      ".productView-nav .productView-img-container," +
      ".productView-nav img{" +
      "max-width:100%!important;height:auto!important}" +
      ".productView-thumbnail-wrapper," +
      ".productView-thumbnail-wrapper.is-hidden-mobile," +
      ".productView-images .productView-for," +
      ".yb-pdp-gallery-polish .productView-thumbnail-wrapper," +
      ".yb-pdp-gallery-polish .productView-thumbnail-wrapper.is-hidden-mobile," +
      ".yb-pdp-gallery-polish .productView-for{" +
      "display:block!important;visibility:visible!important;height:auto!important;max-height:none!important;" +
      "margin:8px 0 0!important;padding:0!important;overflow-x:auto!important;overflow-y:visible!important;" +
      "pointer-events:auto!important;opacity:1!important;-webkit-overflow-scrolling:touch!important;" +
      "max-width:100%!important}" +
      ".yb-pdp-gallery-polish .productView-for.slick-initialized .slick-slide," +
      ".yb-pdp-gallery-polish .productView-thumbnail," +
      ".yb-pdp-gallery-polish .productView-thumbnail-link{" +
      "width:64px!important;min-width:64px!important;max-width:64px!important;height:64px!important;" +
      "display:block!important;visibility:visible!important;opacity:1!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link{padding:0!important;border-radius:8px!important;overflow:hidden!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link::after{display:none!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link img{position:static!important;transform:none!important;width:100%!important;height:100%!important;object-fit:cover!important}" +
      ".productView-title," +
      ".productView .productView-title," +
      "h1.productView-title{" +
      "font-size:1.15rem!important;line-height:1.35!important;overflow-wrap:anywhere!important;word-break:break-word!important}" +
      ".productView-options," +
      ".swatch," +
      ".form-swatch{" +
      "max-width:100%!important;min-width:0!important}" +
      ".swatch .swatch-element label," +
      ".swatch-element label," +
      ".swatch-view-item{" +
      "min-width:44px!important;min-height:44px!important}" +
      ".productView .yb-pdp-buybox," +
      ".productView-top.yb-pdp-3col-row > .yb-pdp-buybox," +
      ".productView-product," +
      ".productView-buttons," +
      ".product-form__buttons{" +
      "width:100%!important;max-width:100%!important;min-width:0!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .productView-groupTop," +
      ".productView .yb-pdp-buybox .pvGroup-row," +
      ".productView .yb-pdp-buybox .product-form__buttons," +
      ".productView .yb-pdp-buybox .productView-action{" +
      "flex-wrap:wrap!important;width:100%!important;max-width:100%!important}" +
      ".productView-quantity," +
      ".quantity," +
      ".productView .quantity{" +
      "max-width:100%!important}" +
      ".yambaba-seller-fulfillment," +
      ".yb-sold-by-yambaba," +
      ".yb-buybox-soldby{" +
      "max-width:100%!important;overflow-wrap:anywhere!important}" +
      ".productView-moreItem:has(.product-customInformation)," +
      ".product-customInformation," +
      ".yb-pdp-native-policy," +
      ".yb-pdp-policy," +
      ".yb-pdp-policy--wide{" +
      "display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}" +
      "#yb-pdp-com-disclosure{display:block!important;height:auto!important;overflow:visible!important;max-width:100%!important}" +
      ".related-products," +
      ".product-recently-viewed," +
      ".halo-block{" +
      "max-width:100%!important;overflow-x:auto!important}" +
      "}";
    (document.head || document.documentElement).appendChild(style);
  })();

  // Share panel stays in-flow at ~300px even when invisible — that clips past
  // the buy column. Inject containment CSS early so it wins over stale theme CSS.
  (function injectShareContainCss() {
    if (document.getElementById("yb-pdp-share-contain")) return;
    const style = document.createElement("style");
    style.id = "yb-pdp-share-contain";
    style.textContent =
      ".productView .yb-pdp-buybox," +
      ".productView-top.yb-pdp-3col-row > .yb-pdp-buybox{" +
      "overflow:visible!important;padding-right:20px!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .productView-groupTop," +
      ".productView .yb-pdp-buybox .pvGroup-row," +
      ".productView .yb-pdp-buybox .product-form__buttons," +
      ".productView .yb-pdp-buybox .productView-action{" +
      "display:flex!important;flex-wrap:nowrap!important;align-items:center!important;" +
      "gap:6px!important;max-width:100%!important;min-width:0!important;" +
      "overflow:visible!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .productView-buttons{" +
      "display:block!important;max-width:100%!important;min-width:0!important;" +
      "overflow:visible!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .productView-groupTop," +
      ".productView .yb-pdp-buybox .pvGroup-row," +
      ".productView .yb-pdp-buybox .product-form__buttons," +
      ".productView .yb-pdp-buybox .productView-action{width:100%!important}" +
      ".productView .yb-pdp-buybox share-button.share-button," +
      ".productView .yb-pdp-buybox .share-button," +
      ".productView .yb-pdp-buybox .productView-share," +
      ".productView .yb-pdp-buybox .scoder-socialShare{" +
      "position:relative!important;display:inline-flex!important;align-items:center!important;" +
      "justify-content:center!important;flex:0 0 36px!important;width:36px!important;" +
      "min-width:36px!important;max-width:36px!important;height:36px!important;" +
      "margin:0!important;right:0!important;left:auto!important;float:none!important;" +
      "overflow:visible!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .share-button .share-content{" +
      "position:relative!important;width:36px!important;min-width:36px!important;" +
      "max-width:36px!important;height:36px!important;overflow:visible!important}" +
      ".productView .yb-pdp-buybox .share-button .share-button__button{" +
      "width:36px!important;height:36px!important;min-width:36px!important;" +
      "padding:0!important;margin:0!important;display:inline-flex!important;" +
      "align-items:center!important;justify-content:center!important}" +
      ".productView .yb-pdp-buybox .share-button .share-button__fallback{" +
      "position:absolute!important;top:calc(100% + 8px)!important;right:0!important;" +
      "left:auto!important;width:min(280px,calc(100vw - 48px))!important;" +
      "max-width:280px!important;z-index:40!important;box-sizing:border-box!important;" +
      "pointer-events:none!important}" +
      ".productView .yb-pdp-buybox .share-button.is-open .share-button__fallback," +
      ".productView .yb-pdp-buybox .share-button[open] .share-button__fallback," +
      ".productView .yb-pdp-buybox .share-button .share-button__fallback[aria-hidden='false']," +
      ".productView .yb-pdp-buybox .share-button .share-button__fallback:not([hidden]){" +
      "pointer-events:auto!important}" +
      ".productView .yb-pdp-buybox #product-add-to-cart," +
      ".productView .yb-pdp-buybox button[name='add']," +
      ".productView .yb-pdp-buybox .product-form__submit{" +
      "flex:1 1 auto!important;min-width:0!important;max-width:100%!important}" +
      ".productView-top.yb-pdp-3col-row{overflow-x:hidden!important}";
    (document.head || document.documentElement).appendChild(style);
  })();

  const DUMMY =
    /lorem|ipsum|comodous|drostique|pharetro|milancelos|cosmopolis|nam tempus turpis|mattis laoreet|divamus|molestie egestas|complete orders|unopened items within 30 days/i;
  const EMPTY_COPY =
    /^(additional information|product details|description|custom tab|shipping|returns?|refunds?)[\s.]*$/i;
  const FACT_LABELS = {
    brand: "brand",
    vendor: "brand",
    sku: "sku",
    "product type": "productType",
    type: "productType",
    category: "category",
    warranty: "warranty",
  };

  function parseFacts() {
    const el = document.querySelector("[data-yb-facts]");
    if (!el) return {};
    const raw = el.getAttribute("data-yb-facts") || "";
    try {
      return JSON.parse(raw.replace(/&quot;/g, '"').replace(/&amp;/g, "&")) || {};
    } catch {
      return {};
    }
  }

  function hideFalseFulfillmentClaims() {
    document.querySelectorAll(".yambaba-seller-fulfillment__delivery").forEach((node) => {
      node.style.setProperty("display", "none", "important");
    });
    document.querySelectorAll(".product-customInformation__popup p").forEach((node) => {
      if (/fulfilled and delivered by\s+yambaba store/i.test(textOf(node))) {
        node.style.setProperty("display", "none", "important");
      }
    });
  }

  function compactProductLoadingSpinner() {
    if (document.getElementById("yb-storefront-speed-style")) return;
    const style = document.createElement("style");
    style.id = "yb-storefront-speed-style";
    style.textContent =
      "body.show_image_loading .data-lazy-loading,body.template-product .data-lazy-loading," +
      ".adaptive_height img.lazyload+.data-lazy-loading,.adaptive_height img.lazyloading+.data-lazy-loading," +
      ".productView-image .data-lazy-loading,.media .data-lazy-loading{display:none!important;" +
      "width:0!important;height:0!important;border:0!important;animation:none!important}" +
      "body.template-product .loadingOverlay,.loadingOverlay{display:none!important}" +
      "body.template-product .media img.lazyload,body.template-product .media img.lazyloading," +
      "body.show_image_loading .adaptive_height img.lazyload," +
      "body.show_image_loading .adaptive_height img.lazyloading{opacity:1!important}";
    (document.head || document.documentElement).appendChild(style);
  }

  function renderPrincipalSellerBadge() {
    let model = "";
    const el = document.querySelector("[data-yb-seller-model]");
    if (el) {
      model = String(el.getAttribute("data-yb-seller-model") || "").toUpperCase();
    }
    if (!model) {
      const factsEl = document.querySelector("[data-yb-facts]");
      if (factsEl) {
        try {
          const raw = factsEl.getAttribute("data-yb-facts") || "";
          const parsed = JSON.parse(raw.replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
          model = String(parsed.sellerModel || "").toUpperCase();
        } catch {
          /* ignore */
        }
      }
    }
    if (model !== "YAMBABA_PRINCIPAL") return;

    document.querySelectorAll(".yambaba-seller-fulfillment__vendor").forEach((node) => {
      node.textContent = "YamBaba";
    });

    // Buy-box chrome owns the visible "Sold by" line so we do not duplicate it
    // next to the price. Keep vendor-node rewrites above for leftover theme copy.
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function textOf(el) {
    return (el && el.textContent ? el.textContent : "").replace(/\s+/g, " ").trim();
  }

  function takeFact(facts, key, value) {
    const clean = String(value || "").replace(/\s+/g, " ").trim();
    if (!key || !clean || facts[key]) return;
    facts[key] = clean;
  }

  function scrapeLabelValue(facts, label, value) {
    const field = FACT_LABELS[String(label || "").toLowerCase().replace(/:$/, "").trim()];
    if (field) takeFact(facts, field, value);
  }

  function scrapeFacts() {
    const facts = parseFacts();
    const root =
      document.querySelector(".productView-tabbing, product-tab, .productView-bottom") ||
      document;

    root.querySelectorAll("tr").forEach((tr) => {
      const cells = Array.from(tr.querySelectorAll("th, td"));
      if (cells.length >= 2) scrapeLabelValue(facts, textOf(cells[0]), textOf(cells[1]));
    });

    root.querySelectorAll("p, li, div.yb-pdp-kv").forEach((el) => {
      const strong = el.querySelector("strong, b");
      if (!strong) return;
      const label = textOf(strong).replace(/:$/, "");
      const value = textOf(el).slice(textOf(strong).length).replace(/^[:\s]+/, "");
      scrapeLabelValue(facts, label, value);
    });

    return facts;
  }

  function card(title, body) {
    return (
      '<article class="yb-pdp-card">' +
      '<h3 class="yb-pdp-card__title">' +
      title +
      "</h3>" +
      '<div class="yb-pdp-card__body">' +
      body +
      "</div></article>"
    );
  }

  function parseYbSpecs(text) {
    const src = String(text || "");
    const marked = src.match(/\[YB-SPECS\]([\s\S]*?)(?:\[\/YB-SPECS\]|$)/i);
    const body = marked ? marked[1] : "";
    const rows = [];
    if (body) {
      body.split("|").forEach((part) => {
        const idx = part.indexOf(":");
        if (idx < 1) return;
        const key = part.slice(0, idx).replace(/\s+/g, " ").trim();
        let value = part.slice(idx + 1).replace(/\s+/g, " ").trim();
        value = value.replace(/\[\/YB-SPECS\].*$/i, "").trim();
        if (key && value && key.length <= 40 && value.length <= 120) rows.push([key, value]);
      });
    }
    return { rows: rows.slice(0, 20), raw: marked ? marked[0] : "" };
  }

  const SPECS_STORE_ID = "yb-pdp-specs-data";

  function readStoredSpecs() {
    try {
      const el = document.getElementById(SPECS_STORE_ID);
      if (el && el.textContent) {
        const rows = JSON.parse(el.textContent);
        if (Array.isArray(rows) && rows.length) return rows;
      }
    } catch (e) {}
    try {
      const raw = sessionStorage.getItem("yb-specs:" + location.pathname);
      if (raw) {
        const rows = JSON.parse(raw);
        if (Array.isArray(rows) && rows.length) return rows;
      }
    } catch (e) {}
    return [];
  }

  function storeSpecs(rows) {
    if (!rows || !rows.length) return;
    const payload = JSON.stringify(rows.slice(0, 20));
    let el = document.getElementById(SPECS_STORE_ID);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/json";
      el.id = SPECS_STORE_ID;
      (document.body || document.documentElement).appendChild(el);
    }
    el.textContent = payload;
    try {
      sessionStorage.setItem("yb-specs:" + location.pathname, payload);
    } catch (e) {}
  }

  function captureSpecsFromDom() {
    const stored = readStoredSpecs();
    if (stored.length) return stored;
    const haystack = [
      collectSourceHtml(),
      document.documentElement ? document.documentElement.innerHTML.slice(0, 250000) : "",
    ].join("\n");
    const parsed = parseYbSpecs(haystack);
    if (parsed.rows.length) {
      storeSpecs(parsed.rows);
      return parsed.rows;
    }
    return [];
  }

  function specsCard(rows) {
    if (!rows || !rows.length) return "";
    const items = rows
      .map(
        ([k, v]) =>
          '<div class="yb-pdp-kv"><span class="yb-pdp-kv__label">' +
          escapeHtml(k) +
          '</span><span class="yb-pdp-kv__value">' +
          escapeHtml(v) +
          "</span></div>",
      )
      .join("");
    return (
      '<article class="yb-pdp-card yb-pdp-card--specs">' +
      '<h3 class="yb-pdp-card__title">Specifications</h3>' +
      '<div class="yb-pdp-kv-row">' +
      items +
      "</div></article>"
    );
  }

  function stripSpecsFromDescription(desc, rawMarker) {
    if (!desc) return;
    let html = desc.innerHTML || "";
    if (rawMarker) html = html.split(rawMarker).join("");
    html = html.replace(/\[YB-SPECS\][\s\S]*?\[\/YB-SPECS\]/gi, "");
    html = html.replace(/\[YB-SPECS\][^<\[]{0,400}/i, "");
    html = html.replace(/<p>\s*Specifications\s*<\/p>/i, "");
    desc.innerHTML = html.trim();
    const text = textOf(desc);
    if (/^Specifications/i.test(text) || /^\[YB-SPECS\]/i.test(text)) {
      desc.textContent = text
        .replace(/^\[YB-SPECS\][\s\S]*?(\[\/YB-SPECS\])?\s*/i, "")
        .replace(/^Specifications\s*/i, "")
        .replace(/^\s+/, "");
    }
  }

  function placeSpecificationsCard(info, desc) {
    if (!info) return;
    const rows = captureSpecsFromDom();
    if (!rows.length) return;
    const extras = Array.from(document.querySelectorAll(".yb-pdp-card--specs"));
    extras.forEach((n, i) => {
      if (i > 0) n.remove();
    });
    let card = info.querySelector(".yb-pdp-card--specs");
    if (!card) {
      const html = specsCard(rows);
      if (desc && desc.parentNode) desc.insertAdjacentHTML("afterend", html);
      else info.insertAdjacentHTML("beforeend", html);
    }
    if (desc) stripSpecsFromDescription(desc, "");
  }

  function watchSpecificationsCard() {
    if (window.__ybSpecsWatch) return;
    window.__ybSpecsWatch = 1;
    let ticks = 0;
    const obs = new MutationObserver(() => {
      ticks += 1;
      if (ticks > 80) {
        obs.disconnect();
        return;
      }
      const info =
        document.querySelector(".yb-pdp-info") ||
        document.querySelector(".productView-product") ||
        document.querySelector(".productView-details");
      if (!info) return;
      if (info.querySelector(".yb-pdp-card--specs")) return;
      const desc = info.querySelector(".yb-pdp-info-desc, .productView-desc");
      placeSpecificationsCard(info, desc);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 60000);
  }

  function factsCard(facts) {
    const rows = [];
    if (facts.brand) rows.push(["Brand", facts.brand]);
    if (facts.sku) rows.push(["SKU", facts.sku]);
    if (facts.productType) rows.push(["Product type", facts.productType]);
    if (facts.category) rows.push(["Category", facts.category]);
    if (facts.expiryLine || facts.expiry) {
      rows.push(["Expiry", facts.expiryLine || facts.expiry]);
    }
    if (facts.warranty) rows.push(["Warranty", facts.warranty]);
    if (!rows.length) return "";
    const items = rows
      .map(
        ([k, v]) =>
          '<div class="yb-pdp-kv"><span class="yb-pdp-kv__label">' +
          escapeHtml(k) +
          '</span><span class="yb-pdp-kv__value">' +
          escapeHtml(v) +
          "</span></div>",
      )
      .join("");
    return (
      '<article class="yb-pdp-card yb-pdp-card--facts">' +
      '<h3 class="yb-pdp-card__title">Product details</h3>' +
      '<div class="yb-pdp-kv-row">' +
      items +
      "</div></article>"
    );
  }

  const MNEMONIC_SHIP =
    '<span class="yb-pdp-mnemonic" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 7h11v10H3z"/><path d="M14 11h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg></span>';
  const MNEMONIC_RETURN =
    '<span class="yb-pdp-mnemonic" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 7H4v5"/><path d="M4 12a8 8 0 1 0 2.3-5.7L4 7"/></svg></span>';

  const POLICY_GRID =
    '<div class="yb-pdp-policy yb-pdp-policy--wide">' +
    card(
      MNEMONIC_SHIP + " Shipping",
      "<p>YamBaba delivers marketplace orders across the UAE. Estimated delivery is shown at checkout and depends on your address and the option you select.</p><p>Sellers pack orders properly. Inspect parcels on receipt and report transit damage within 24 hours.</p>",
    ) +
    card(
      MNEMONIC_RETURN + " Returns &amp; refunds",
      "<p><strong>Seller-fault</strong> (wrong, faulty, damaged, or not as described): eligible merchandise and original shipping refunds after approval — you are not charged for seller-fault return logistics.</p>" +
        "<p><strong>Change of mind:</strong> 5 days from receipt. Unused, original condition and packaging. You normally deliver the item back to the YamBaba Fulfilment Centre. Original delivery you paid is not refunded. If original delivery was free/subsidised, an <strong>Applicable Change-of-Mind Outbound Delivery Recovery</strong> may reduce the merchandise refund (exact amount shown when you confirm a return). Final refunds stay subject to inspection.</p>" +
        '<p class="yb-pdp-card__note"><a href="mailto:info@yambaba.ae">info@yambaba.ae</a> · <a href="/policies/refund-policy">Refund policy</a> · <a href="/policies/shipping-policy">Shipping policy</a> · <a href="https://portal.yambaba.ae/returns/customer" target="_blank" rel="noopener">Start a return</a></p>',
    ) +
    "</div>";

  function isPolicyTitle(value) {
    const t = String(value || "")
      .toLowerCase()
      .replace(/[:.\s]+$/g, "")
      .trim();
    return (
      t === "shipping" ||
      t.indexOf("returns") === 0 ||
      t.indexOf("refund") >= 0 ||
      t === "product details" ||
      t === "about this product" ||
      t === "additional information" ||
      t === "warranty"
    );
  }

  function blockKind(el) {
    if (!el || el.nodeType !== 1) return "";
    const tag = el.tagName;
    if (/^H[1-6]$/.test(tag)) return isPolicyTitle(textOf(el)) ? "policy" : "section";
    const strong = el.querySelector && el.querySelector("strong, b");
    const strongText = strong ? textOf(strong).replace(/:$/, "") : "";
    const full = textOf(el);
    if (strong && isPolicyTitle(strongText)) {
      return full.length < Math.max(80, strongText.length + 8) ? "policy" : "policy-block";
    }
    if (isPolicyTitle(full) && full.length < 48) return "policy";
    return "";
  }

  function isSpecTable(table) {
    // Do not remove our own YamBaba specifications block.
    // The cleaning step below removes tables it thinks are "product facts"
    // (brand/vendor/SKU/type). Our specs table is also a table, so we skip it.
    if (table && table.closest && table.closest("[data-yambaba-specifications]")) {
      return false;
    }
    const t = textOf(table).toLowerCase();
    if (!t || t.length > 500) return false;
    let hits = 0;
    if (/\bbrand\b/.test(t) || /\bvendor\b/.test(t)) hits += 1;
    if (/\bsku\b/.test(t)) hits += 1;
    if (/product type|\btype\b/.test(t)) hits += 1;
    return hits >= 2;
  }

  function cleanDescription(html) {
    // Preserve our YamBaba specifications block.
    // The cleaning heuristics below (policy/fact extraction) can otherwise
    // remove the content from the visible description even when Shopify
    // successfully stores it in `descriptionHtml`.
    const SPEC_START = "<!-- yambaba-specifications-start -->";
    const SPEC_END = "<!-- yambaba-specifications-end -->";
    let preservedSpecBlock = "";
    if (typeof html === "string") {
      const startIdx = html.indexOf(SPEC_START);
      const endIdx = html.indexOf(SPEC_END);
      if (startIdx !== -1 && endIdx !== -1 && endIdx > startIdx) {
        const endExclusive = endIdx + SPEC_END.length;
        preservedSpecBlock = html.slice(startIdx, endExclusive);
        html = html.slice(0, startIdx) + "__YAMBABA_SPECS_BLOCK__" + html.slice(endExclusive);
      }
    }

    const wrap = document.createElement("div");
    wrap.innerHTML = html || "";
    wrap
      .querySelectorAll(
        ".yb-policy-tab, .yb-pdp-stack, .yb-pdp-grid, .yb-pdp-card, .yb-facts, .yb-warranty, [data-yambaba-facts], [data-yb-facts], [data-yambaba-warranty], .toggle-title, .tab-showMore, .tab-popup-header, .pdViewTab-close",
      )
      .forEach((n) => n.remove());
    wrap.querySelectorAll("table").forEach((table) => {
      if (isSpecTable(table)) table.remove();
    });
    wrap.querySelectorAll("p, li, div").forEach((el) => {
      const strong = el.querySelector("strong, b");
      if (!strong) return;
      const label = textOf(strong).replace(/:$/, "").toLowerCase();
      if (FACT_LABELS[label] && textOf(el).length < 140) el.remove();
    });

    const kids = Array.from(wrap.children);
    kids.forEach((el, idx) => {
      const kind = blockKind(el);
      if (kind === "policy-block") {
        el.remove();
        return;
      }
      if (kind !== "policy") return;
      el.remove();
      for (let i = idx + 1; i < kids.length; i += 1) {
        const next = kids[i];
        if (!next || !next.parentNode) continue;
        const nextKind = blockKind(next);
        if (nextKind === "policy" || nextKind === "policy-block" || nextKind === "section") break;
        next.remove();
      }
    });

    wrap.querySelectorAll("ul, ol").forEach((list) => {
      if (!textOf(list)) list.remove();
    });

    const text = textOf(wrap);
    if (!text || EMPTY_COPY.test(text) || DUMMY.test(text)) {
      if (preservedSpecBlock) return preservedSpecBlock;
      return "";
    }

    const cleaned = wrap.innerHTML.trim();
    if (preservedSpecBlock) {
      return cleaned.replace("__YAMBABA_SPECS_BLOCK__", preservedSpecBlock);
    }
    return cleaned;
  }

  function parseJsonAttr(el, name) {
    const raw = el.getAttribute(name) || "";
    if (!raw) return null;
    try {
      return JSON.parse(raw.replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
    } catch {
      return null;
    }
  }

  function extractWarranty(html) {
    const wrap = document.createElement("div");
    wrap.innerHTML = html || "";
    const result = { line: "", policy: "", html: "", trackable: false, coverage: "" };
    const node = wrap.querySelector(
      "[data-yb-warranty], [data-yambaba-warranty], .yb-warranty",
    );
    if (node) {
      const parsed = parseJsonAttr(node, "data-yb-warranty");
      if (parsed && typeof parsed === "object") {
        result.line = parsed.line || "";
        result.policy = parsed.policy || "";
        result.trackable = !!parsed.trackable;
        result.coverage = String(parsed.coverage || "").toUpperCase();
      }
      const clone = node.cloneNode(true);
      Array.from(clone.querySelectorAll("p")).forEach((p) => {
        if (textOf(p).toLowerCase() === "warranty") p.remove();
      });
      result.html = clone.innerHTML.trim();
      if (!result.line) result.line = textOf(clone.querySelector("p, strong, h3, h4") || clone);
    }
    if (!result.line && !result.html) {
      const kids = Array.from(wrap.children);
      kids.forEach((el, idx) => {
        const headingSource = /^H[1-6]$/.test(el.tagName)
          ? el
          : el.querySelector("strong, b") || el;
        const heading = textOf(headingSource).toLowerCase().replace(/:$/, "");
        if (heading !== "warranty") return;
        if (textOf(el).length > 80 && !/^H[1-6]$/.test(el.tagName)) return;
        const parts = [];
        for (let i = idx + 1; i < kids.length; i += 1) {
          const kind = blockKind(kids[i]);
          if (kind === "policy" || kind === "policy-block" || kind === "section") break;
          parts.push(kids[i].outerHTML);
        }
        if (parts.length) result.html = parts.join("");
      });
    }
    return result;
  }

  function inferWarrantyCoverage(warranty) {
    const explicit = String(warranty && warranty.coverage ? warranty.coverage : "")
      .toUpperCase()
      .replace(/[\s-]+/g, "_");
    if (
      /^(NONE|MANUFACTURER|VENDOR|PLATFORM|SERVICE_CENTER)$/.test(explicit)
    ) {
      return explicit;
    }
    const blob = (
      (warranty && (warranty.line || warranty.policy || "")) +
      " " +
      String((warranty && warranty.html) || "").replace(/<[^>]+>/g, " ")
    ).toLowerCase();
    if (/service[- ]center|authori[sz]ed service/.test(blob)) return "SERVICE_CENTER";
    if (/manufacturer|brand warranty/.test(blob)) return "MANUFACTURER";
    if (/yambaba|platform warranty/.test(blob)) return "PLATFORM";
    if (/seller warranty|vendor warranty/.test(blob)) return "VENDOR";
    if (/no warranty|none\b/.test(blob) && !/unless/.test(blob)) return "NONE";
    return warranty && (warranty.line || warranty.html || warranty.policy)
      ? "VENDOR"
      : "NONE";
  }

  function warrantyCard(warranty) {
    const coverage = inferWarrantyCoverage(warranty);
    const label =
      coverage === "MANUFACTURER"
        ? "Manufacturer warranty"
        : coverage === "VENDOR"
          ? "Seller warranty"
          : coverage === "PLATFORM"
            ? "YamBaba warranty"
            : coverage === "SERVICE_CENTER"
              ? "Service-center warranty"
              : "Warranty";
    const chunks = [];
    if (warranty && warranty.html) {
      chunks.push(warranty.html);
    } else {
      if (warranty && warranty.line) {
        chunks.push("<p><strong>" + escapeHtml(warranty.line) + "</strong></p>");
      }
      if (warranty && warranty.trackable) {
        chunks.push(
          "<p>Tracked against the sold serial / IMEI. Keep your order invoice and unit identifier for any claim.</p>",
        );
      }
      if (warranty && warranty.policy) {
        chunks.push("<p>" + escapeHtml(warranty.policy).replace(/\n/g, "<br>") + "</p>");
      }
    }
    if (!chunks.length) {
      chunks.push(
        "<p><strong>No warranty</strong> unless the seller stated one on this listing.</p><p>If a warranty is listed, keep your order invoice. Claims for faulty or damaged items must be made within 24 hours of delivery.</p>",
      );
    }
    return (
      '<div class="yb-pdp-warranty yb-pdp-warranty--' +
      coverage.toLowerCase() +
      '" data-yb-warranty-coverage="' +
      coverage +
      '">' +
      card(label, chunks.join("")) +
      "</div>"
    );
  }

  /** Full listing copy captured before tab host is replaced by yb-pdp-stack. */
  var cachedPdpDescriptionHtml = String(window.__ybPdpDescriptionHtml || "").trim();

  function plainTextLen(html) {
    const probe = document.createElement("div");
    probe.innerHTML = html || "";
    return textOf(probe).length;
  }

  function rememberPdpDescriptionHtml(html) {
    const next = String(html || "").trim();
    if (!next) return;
    const probe = document.createElement("div");
    probe.innerHTML = next;
    const plain = textOf(probe);
    if (!plain || DUMMY.test(plain)) return;
    if (!cachedPdpDescriptionHtml || plainTextLen(next) > plainTextLen(cachedPdpDescriptionHtml)) {
      cachedPdpDescriptionHtml = next;
      try {
        window.__ybPdpDescriptionHtml = next;
      } catch (e) {}
    }
  }

  function capturePdpDescriptionFromPage() {
    const selectors = [
      '.tab-content[id*="description"] .toggle-content',
      '[id^="tab-description"] .toggle-content',
      "#tab-description .toggle-content",
      ".tab-content.is-active .toggle-content",
      ".productView-tab .toggle-content",
      ".tabs-contents .toggle-content",
      "[data-product-description]",
      ".product-description",
      ".product-single__description",
      ".productView-bottom .rte",
      ".product-details .rte",
      ".scoder-text-format",
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (el.closest(".yb-pdp-stack")) return;
        rememberPdpDescriptionHtml(el.innerHTML);
      });
    });
    document.querySelectorAll('script[type="application/ld+json"]').forEach((node) => {
      try {
        const data = JSON.parse(node.textContent || "{}");
        const items = Array.isArray(data) ? data : [data];
        items.forEach((item) => {
          if (item && item["@type"] === "Product" && item.description) {
            rememberPdpDescriptionHtml(
              "<p>" + escapeHtml(decodeHtmlEntitiesDeep(String(item.description))) + "</p>",
            );
          }
        });
      } catch (e) {}
    });
    return cachedPdpDescriptionHtml;
  }

  function collectSourceHtml() {
    capturePdpDescriptionFromPage();
    const chunks = [];
    const seen = [];
    const selectors = [
      '.tab-content[id*="description"] .toggle-content',
      '[id^="tab-description"] .toggle-content',
      ".tab-content.is-active .toggle-content",
      ".productView-tab .toggle-content",
      ".tabs-contents .toggle-content",
      "[data-product-description]",
      ".product-description",
      ".product-single__description",
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (seen.indexOf(el) !== -1) return;
        if (el.closest(".yb-pdp-stack")) return;
        seen.push(el);
        rememberPdpDescriptionHtml(el.innerHTML);
        chunks.push(el.innerHTML);
      });
    });
    if (!chunks.length) {
      const rte = document.querySelector(".productView-bottom .rte, .product-details .rte, .scoder-text-format");
      if (rte) {
        rememberPdpDescriptionHtml(rte.innerHTML);
        chunks.push(rte.innerHTML);
      }
    }
    if (!chunks.length && cachedPdpDescriptionHtml) return cachedPdpDescriptionHtml;
    let best = "";
    chunks.forEach((html) => {
      if (plainTextLen(html) > plainTextLen(best)) best = html;
    });
    if (plainTextLen(cachedPdpDescriptionHtml) > plainTextLen(best)) {
      return cachedPdpDescriptionHtml;
    }
    return best || chunks.join("\n") || cachedPdpDescriptionHtml;
  }

  function bestDescriptionSourceHtml() {
    capturePdpDescriptionFromPage();
    const live = collectSourceHtml();
    if (plainTextLen(cachedPdpDescriptionHtml) > plainTextLen(live)) {
      return cachedPdpDescriptionHtml;
    }
    return live || cachedPdpDescriptionHtml;
  }

  function warrantyFromFacts(facts) {
    const line = String(facts.warrantyLine || facts.warranty || "").trim();
    if (!line || /^no warranty/i.test(line)) return null;
    return {
      line,
      policy: String(facts.warrantyPolicy || "").trim(),
      trackable: !!facts.warrantyTrackable,
      coverage: String(facts.warrantyCoverage || "").toUpperCase(),
      html: "",
    };
  }

  function buildStack(facts, descriptionHtml) {
    const extracted = extractWarranty(descriptionHtml);
    const fromFacts = warrantyFromFacts(facts);
    const warranty = fromFacts
      ? {
          line: extracted.line || fromFacts.line,
          policy: extracted.policy || fromFacts.policy,
          trackable: extracted.trackable || fromFacts.trackable,
          coverage: extracted.coverage || fromFacts.coverage,
          html: extracted.html,
        }
      : extracted;
    const scraped = String(facts.warranty || facts.warrantyLine || "").trim();
    if (warranty.line) facts.warranty = warranty.line;
    else if (/^none\b/i.test(scraped) || /no warranty/i.test(scraped)) {
      facts.warranty = "No warranty";
    } else if (scraped && scraped.length <= 80) {
      facts.warranty = scraped;
    } else {
      facts.warranty = "No warranty";
    }
    const parts = [];
    parts.push(POLICY_GRID);
    parts.push(warrantyCard(warranty));
    return '<div class="yb-pdp-stack">' + parts.join("") + "</div>";
  }

  function findHost() {
    return (
      document.querySelector(".productView-tabbing") ||
      document.querySelector("product-tab") ||
      document.querySelector(".productView-bottom") ||
      document.querySelector(".productView-tab")
    );
  }

  function stackIsPlaced() {
    const stack = document.querySelector(".yb-pdp-stack");
    if (!stack) return false;
    const host = findHost();
    const inView = !!stack.closest(".productView");
    if (!(inView || (host && host.contains(stack)))) return false;
    return !!(
      stack.querySelector(".yb-pdp-policy--wide") ||
      stack.querySelector(".yb-pdp-warranty")
    );
  }

  function hideNativeDuplicates() {
    document
      .querySelectorAll(
        ".yb-facts, .yb-warranty, [data-yambaba-facts], [data-yambaba-warranty]",
      )
      .forEach((el) => {
        if (el.closest(".yb-pdp-stack")) return;
        el.classList.add("yb-pdp-hidden");
        el.setAttribute("hidden", "");
        el.style.display = "none";
      });
    // Raw description belongs in the middle info column only
    document
      .querySelectorAll(
        ".yb-pdp-buybox .productView-desc, .yb-pdp-details-shell .productView-desc",
      )
      .forEach((el) => {
        el.classList.add("yb-pdp-hidden");
        el.setAttribute("hidden", "");
        el.style.display = "none";
      });
    document.querySelectorAll(".yb-pdp-info .productView-desc").forEach((el) => {
      el.classList.remove("yb-pdp-hidden");
      el.removeAttribute("hidden");
      el.style.display = "";
    });
  }

  function readAplusPayload() {
    const jsonEl = document.getElementById("yb-aplus-json");
    if (jsonEl) {
      try {
        const data = JSON.parse(jsonEl.textContent || "{}");
        const url = String(data.url || data.desktopUrl || "").trim();
        const tabletUrl = String(data.tabletUrl || "").trim();
        const mobileUrl = String(data.mobileUrl || "").trim();
        const alt = String(data.alt || "").trim();
        const desktopOk = /^https?:\/\//i.test(url);
        const tabletOk = /^https?:\/\//i.test(tabletUrl);
        const mobileOk = /^https?:\/\//i.test(mobileUrl);
        if (desktopOk || tabletOk || mobileOk) {
          return {
            url: desktopOk ? url : tabletOk ? tabletUrl : mobileUrl,
            tabletUrl: tabletOk ? tabletUrl : "",
            mobileUrl: mobileOk ? mobileUrl : "",
            alt,
          };
        }
      } catch (_) {
        /* ignore */
      }
    }
    const meta = document.querySelector('meta[name="yb-aplus-image"]');
    const metaUrl = meta?.getAttribute("content")?.trim() || "";
    if (/^https?:\/\//i.test(metaUrl)) {
      return { url: metaUrl, tabletUrl: "", mobileUrl: "", alt: "" };
    }
    return null;
  }

  function placeAplusContent() {
    if (document.querySelector(".yb-aplus")) return;
    const aplus = readAplusPayload();
    if (!aplus) return;

    const wrap = document.createElement("div");
    wrap.className = "yb-aplus";
    wrap.setAttribute("data-yb-aplus", "1");

    const picture = document.createElement("picture");
    picture.className = "yb-aplus__picture";

    if (aplus.mobileUrl) {
      const mobileSource = document.createElement("source");
      mobileSource.media = "(max-width: 767px)";
      mobileSource.srcset = aplus.mobileUrl;
      picture.appendChild(mobileSource);
    }

    const tabletSrc = aplus.tabletUrl || aplus.url;
    if (tabletSrc && tabletSrc !== aplus.mobileUrl) {
      const tabletSource = document.createElement("source");
      tabletSource.media = "(max-width: 1023px)";
      tabletSource.srcset = tabletSrc;
      picture.appendChild(tabletSource);
    }

    const img = document.createElement("img");
    img.className = "yb-aplus__img";
    img.src = aplus.url;
    img.alt = aplus.alt || "Product details";
    if (aplus.mobileUrl && aplus.url === aplus.mobileUrl && !aplus.tabletUrl) {
      img.width = 750;
      img.height = 1000;
    } else if (aplus.tabletUrl && aplus.url === aplus.tabletUrl) {
      img.width = 1024;
      img.height = 768;
    } else {
      img.width = 1464;
      img.height = 600;
    }
    img.loading = "lazy";
    img.decoding = "async";
    img.fetchPriority = "low";
    picture.appendChild(img);
    wrap.appendChild(picture);

    const heading = Array.from(
      document.querySelectorAll("h2, h3, .section-header, .block-title"),
    ).find((h) => /^related products$/i.test((h.textContent || "").trim()));
    const relatedSection =
      heading?.closest('[id^="shopify-section"]') ||
      heading?.closest("section") ||
      heading?.parentElement ||
      document.querySelector(
        ".related-products, .product-related, .scoder-product-block-sections",
      );

    if (relatedSection) {
      relatedSection.parentElement?.insertBefore(wrap, relatedSection);
    } else {
      const stack = document.querySelector(".yb-pdp-stack");
      if (stack) stack.insertAdjacentElement("afterend", wrap);
    }
  }

  function isPolicyBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    const heading = (
      el.querySelector(
        "h2, h3, h4, .accordion__title, .productView-label, .productView-title",
      )?.textContent || ""
    )
      .trim()
      .toLowerCase();
    if (/(shipping|delivery|returns?|refund)/.test(heading)) return true;
    const cls = String(el.className || "").toLowerCase();
    if (/(shipping|delivery|return|refund)/.test(cls)) return true;
    const start = (el.textContent || "").trim().slice(0, 80).toLowerCase();
    return /^(shipping|delivery|returns?|refund)\b/.test(start);
  }

  function isPriceBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches(".productView-price, .price, [data-product-price]")) return true;
    if (el.querySelector(".productView-price, .price-item, [data-product-price], .price__regular, .price")) {
      const text = (el.textContent || "").toLowerCase();
      // Avoid treating long description blocks that mention AED once
      if (text.length < 220 && /aed|د\.إ|\$|€|£|\d/.test(text)) return true;
    }
    return false;
  }

  function isVariantPickerBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (
      el.matches?.(
        ".productView-options, .swatch, .swatch-view, variant-radios, variant-selects, .product-form__input, [data-option-index], .form-swatch",
      )
    ) {
      return true;
    }
    if (
      el.querySelector(
        ".swatch, .swatch-element, .productView-options, variant-radios, variant-selects, [data-option-index], .form-swatch, .product-form__input",
      )
    ) {
      return true;
    }
    const heading = el.querySelector(
      ".productView-label, legend, .form__label, .option-label, .swatch-label",
    );
    return !!(
      heading &&
      /^(colou?r|size|storage|model|capacity|style|variant|material)\b/i.test(textOf(heading))
    );
  }

  function isBuyBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (isPriceBlock(el)) return true;
    const hasCartUi = !!el.querySelector(
      'form[action*="/cart/add"], .productView-buttons, .productView-form, .product-form, [name="add"], .shopify-payment-button, .product-form__submit, #product-add-to-cart, .productView-quantity, .quantity, .qty-box, .wishlist, .productView-wishlist',
    );
    if (
      isVariantPickerBlock(el) &&
      !el.querySelector("[name='add'], #product-add-to-cart, .productView-buttons, form[action*='/cart/add']")
    ) {
      return false;
    }
    if (hasCartUi) return true;
    const text = (el.textContent || "").toLowerCase();
    return (
      (/add to cart|buy it now|buy now/.test(text) &&
        !!el.querySelector("button, input[type='submit']")) ||
      false
    );
  }

  function columnTarget(el) {
    if (!el || el.nodeType !== 1) return "info";
    if (el.classList && el.classList.contains("yb-pdp-card--specs")) return "info";
    if (el.classList && el.classList.contains("yb-b2b-product-actions")) return "buy";
    if (el.classList && el.classList.contains("yambaba-seller-fulfillment")) return "buy";
    if (el.classList && el.classList.contains("yb-buybox-chrome")) return "buy";
    if (el.classList && el.classList.contains("yb-buybox-warranty")) return "buy";
    if (el.classList && el.classList.contains("yb-price-vat")) return "buy";
    if (el.classList && el.classList.contains("yb-pdp-warranty")) return "info";
    if (isVariantPickerBlock(el) && !el.querySelector("[name='add'], #product-add-to-cart"))
      return "info";
    if (isPolicyBlock(el)) return "policy";
    if (isBuyBlock(el)) return "buy";
    return "info";
  }

  function parkPolicyBlock(el) {
    if (!el) return;
    // Native theme Shipping/Returns (icon blocks) duplicate the wide stack policy.
    el.classList.add("yb-pdp-hidden", "yb-pdp-native-policy");
    el.setAttribute("hidden", "");
    el.style.setProperty("display", "none", "important");
  }

  function readSellerModel() {
    const el = document.querySelector("[data-yb-seller-model]");
    if (el) {
      const model = String(el.getAttribute("data-yb-seller-model") || "").toUpperCase();
      if (model) return model;
    }
    return String(parseFacts().sellerModel || "").toUpperCase();
  }

  function readDynamicVendor() {
    const candidates = [
      document.querySelector(".yambaba-seller-fulfillment__vendor"),
      document.querySelector(".productView-vendor"),
      document.querySelector(".productView-info .vendor"),
      document.querySelector("[itemprop='brand']"),
      document.querySelector(".product__vendor"),
    ];
    for (const el of candidates) {
      const t = textOf(el);
      if (t && !/^sold by/i.test(t)) return t.replace(/^sold by[:\s]*/i, "").trim();
      if (t) return t.replace(/^sold by[:\s]*/i, "").trim();
    }
    const sold = Array.from(document.querySelectorAll("p, span, div")).find((n) =>
      /^sold by\b/i.test(textOf(n)) && textOf(n).length < 80 && !n.closest(".yb-buybox-chrome"),
    );
    if (sold) return textOf(sold).replace(/^sold by[:\s]*/i, "").trim();
    return String(scrapeFacts().brand || "").trim();
  }

  function readShopCommerce() {
    const el = document.getElementById("yb-shop-commerce");
    if (el) {
      try {
        const data = JSON.parse(el.textContent || "{}");
        return {
          shopName: String(data.shopName || "").trim(),
          taxesIncluded: !(data.taxesIncluded === false || data.taxesIncluded === "false"),
          country: String(data.country || "").trim().toUpperCase(),
        };
      } catch (e) {
        /* fall through */
      }
    }
    return { shopName: "", taxesIncluded: true, country: "" };
  }

  function taxTermForCountry(code) {
    if (!code) return "VAT";
    const vat = {
      AE: 1, SA: 1, BH: 1, KW: 1, OM: 1, QA: 1, GB: 1, IE: 1, DE: 1, FR: 1,
      IT: 1, ES: 1, NL: 1, BE: 1, AT: 1, PT: 1, PL: 1, SE: 1, DK: 1, FI: 1,
      NO: 1, CH: 1, ZA: 1, IN: 1,
    };
    if (vat[code]) return "VAT";
    if (code === "US" || code === "CA") return "Sales tax";
    if (code === "AU" || code === "NZ") return "GST";
    return "Tax";
  }

  function readPlatformName() {
    const shop = readShopCommerce().shopName;
    if (shop) return shop;
    const og = document.querySelector('meta[property="og:site_name"]');
    const ogv = og && String(og.getAttribute("content") || "").trim();
    if (ogv) return ogv;
    const logo = document.querySelector(
      ".header-logo img[alt], .logo img[alt], a.header__heading-link img[alt]",
    );
    const alt = logo && String(logo.getAttribute("alt") || "").trim();
    if (alt) return alt.replace(/\s*[-|–].*$/, "").trim();
    return "";
  }

  function principalSoldByName() {
    const platform = readPlatformName();
    if (/^yambaba\b/i.test(platform)) return "YamBaba";
    return platform || "YamBaba";
  }

  function storefrontTermsUrl() {
    try {
      return new URL("/policies/terms-of-service", location.origin).href;
    } catch (e) {
      return "/policies/terms-of-service";
    }
  }

  function parseMoneyAmount(text) {
    const raw = String(text || "").replace(/[^\d.,]/g, "");
    if (!raw) return NaN;
    const normalized = raw.indexOf(",") > raw.indexOf(".")
      ? raw.replace(/\./g, "").replace(",", ".")
      : raw.replace(/,/g, "");
    const n = parseFloat(normalized);
    return Number.isFinite(n) ? n : NaN;
  }

  function sanitizeCompareAt(root) {
    if (!root) return;
    const price = root.querySelector(".price, .productView-price") || root;
    const saleEl =
      price.querySelector(".price-item--sale") ||
      price.querySelector(".price__sale .price-item");
    const compareEls = Array.from(
      price.querySelectorAll(
        ".price-item--regular, .price__compare .price-item, s .price-item, .compare-price, .price__was",
      ),
    );
    const saleAmt = parseMoneyAmount(textOf(saleEl) || textOf(price.querySelector(".price-item")));
    compareEls.forEach((el) => {
      if (saleEl && (el === saleEl || saleEl.contains(el))) return;
      const amt = parseMoneyAmount(textOf(el));
      const invalid =
        !Number.isFinite(amt) ||
        amt <= 0 ||
        (Number.isFinite(saleAmt) && amt <= saleAmt);
      if (invalid) {
        const wrap =
          el.closest(".price__compare, .price__regular, s, .compare-at, .unit-price") || el;
        wrap.style.setProperty("display", "none", "important");
      }
    });
    if (!price.classList.contains("price--on-sale")) {
      price.querySelectorAll(".price__sale").forEach((el) => {
        if (!el.querySelector(".price-item--sale")) {
          el.style.setProperty("display", "none", "important");
        }
      });
    }
  }

  function ensureVatNote(buybox) {
    if (!buybox) return;
    const shop = readShopCommerce();
    const term = taxTermForCountry(shop.country);
    const label = shop.taxesIncluded
      ? "Includes " + term
      : "Excludes " + term;
    let note = buybox.querySelector(".yb-price-vat") || document.querySelector(".yb-price-vat");
    if (!note) {
      note = document.createElement("p");
      note.className = "yb-price-vat";
    }
    note.textContent = label;
    const priceHost =
      buybox.querySelector(".productView-price")?.closest(".productView-moreItem") ||
      buybox.querySelector(".productView-price, .price");
    document.querySelectorAll(".yb-price-vat").forEach((el) => {
      if (el !== note) el.remove();
    });
    if (priceHost) {
      if (note.parentElement !== priceHost.parentElement || note.previousElementSibling !== priceHost) {
        priceHost.insertAdjacentElement("afterend", note);
      }
    } else if (note.parentElement !== buybox) {
      buybox.insertBefore(note, buybox.firstChild);
    }
  }

  function warrantyPartyName(coverage, vendor, brand, platform) {
    if (coverage === "MANUFACTURER") return brand || vendor || "";
    if (coverage === "VENDOR") return vendor || brand || "";
    if (coverage === "PLATFORM") return platform || principalSoldByName();
    if (coverage === "SERVICE_CENTER") return "Authorized service center";
    return "";
  }

  function warrantyPeriodLabel(line) {
    const m = String(line || "").match(
      /(\d+\s*-\s*year|\d+\s*year|\d+\s*-\s*month|\d+\s*month|1-year|1-month)/i,
    );
    if (!m) return "";
    return m[0].replace(/\s+/g, " ").replace(/^(\d+)\s*-\s*/i, "$1-").replace(/year$/i, "Year Warranty").replace(/month$/i, "Month Warranty");
  }

  function readListingWarranty() {
    const node = document.querySelector("[data-yb-warranty]");
    if (node) {
      const parsed = parseJsonAttr(node, "data-yb-warranty");
      if (parsed && typeof parsed === "object") {
        return {
          line: String(parsed.line || "").trim(),
          policy: String(parsed.policy || "").trim(),
          trackable: !!parsed.trackable,
          coverage: String(parsed.coverage || "").toUpperCase(),
          html: node.innerHTML || "",
        };
      }
    }
    const card = document.querySelector(".yb-pdp-warranty");
    if (card) {
      const coverage = String(card.getAttribute("data-yb-warranty-coverage") || "").toUpperCase();
      const line =
        textOf(card.querySelector(".yb-pdp-card__body p, p, strong")) ||
        textOf(card);
      const clean = line.replace(/^warranty\s*/i, "").trim();
      if (
        coverage &&
        coverage !== "NONE" &&
        clean &&
        !/^no warranty/i.test(clean) &&
        !/unless the seller stated/i.test(clean)
      ) {
        return {
          line: clean,
          policy: "",
          trackable: false,
          coverage,
          html: card.innerHTML || "",
        };
      }
    }
    const facts = scrapeFacts();
    const fromFacts = warrantyFromFacts(facts);
    if (fromFacts) return fromFacts;
    const extracted = extractWarranty(collectSourceHtml());
    if (extracted && (extracted.line || extracted.html)) return extracted;
    return {
      line: String(facts.warranty || facts.warrantyLine || "").trim(),
      policy: String(facts.warrantyPolicy || "").trim(),
      coverage: String(facts.warrantyCoverage || "").toUpperCase(),
      html: "",
    };
  }

  function ensureBuyBoxChrome(buybox) {
    if (!buybox) return;
    let chrome = buybox.querySelector(".yb-buybox-chrome");
    if (!chrome) {
      chrome = document.createElement("div");
      chrome.className = "yb-buybox-chrome";
    }
    const model = readSellerModel();
    const vendor = readDynamicVendor();
    const platform = readPlatformName() || principalSoldByName();
    const facts = scrapeFacts();
    const listingWarranty = readListingWarranty();
    const warranty = String(
      listingWarranty.line || facts.warranty || facts.warrantyLine || "",
    ).trim();
    const coverage = inferWarrantyCoverage({
      line: warranty,
      policy: listingWarranty.policy || facts.warrantyPolicy,
      coverage: listingWarranty.coverage || facts.warrantyCoverage,
    });
    const soldName = model === "YAMBABA_PRINCIPAL" ? principalSoldByName() : vendor;
    const trust = [];
    if (soldName) {
      trust.push(
        '<p class="yb-buybox-soldby"><span class="yb-buybox-soldby__label">Sold by</span> ' +
          escapeHtml(soldName) +
          "</p>",
      );
    }
    if (platform) {
      trust.push(
        '<p class="yb-buybox-fulfilled"><span class="yb-buybox-soldby__label">Fulfilled &amp; Delivered by</span> ' +
          escapeHtml(platform) +
          "</p>",
      );
    }
    chrome.innerHTML = trust.join("");
    if (!trust.length) {
      chrome.remove();
      chrome = null;
    }

    let wbox = buybox.querySelector(".yb-buybox-warranty");
    if (!wbox) {
      wbox = document.createElement("div");
      wbox.className = "yb-buybox-warranty";
    }
    const hasWarranty =
      coverage !== "NONE" &&
      warranty &&
      !/^none\b/i.test(warranty) &&
      !/^no warranty/i.test(warranty) &&
      !/unless the seller stated/i.test(warranty);
    wbox.className =
      "yb-buybox-warranty yb-pdp-warranty--" + String(coverage || "none").toLowerCase();
    if (hasWarranty) {
      const period = warrantyPeriodLabel(warranty);
      const party = warrantyPartyName(
        coverage,
        vendor,
        String(facts.brand || "").trim(),
        platform,
      );
      wbox.innerHTML =
        '<div class="yb-buybox-warranty__title">Warranty Available</div>' +
        (period
          ? '<div class="yb-buybox-warranty__period">' + escapeHtml(period) + "</div>"
          : "") +
        '<div class="yb-buybox-warranty__body">' +
        escapeHtml(warranty) +
        "</div>" +
        (party
          ? '<div class="yb-buybox-warranty__by">Warranty by: ' +
            escapeHtml(party) +
            "</div>"
          : "");
    } else {
      wbox.innerHTML =
        '<div class="yb-buybox-warranty__title">No Warranty Available</div>';
    }
    if (chrome && chrome.parentElement !== buybox) buybox.appendChild(chrome);
    if (wbox.parentElement !== buybox) buybox.appendChild(wbox);
  }

  function orderBuyBox(buybox) {
    if (!buybox) return;
    const kids = Array.from(buybox.children);
    const isFormish = (el) =>
      !!el.querySelector?.(
        "form[action*='/cart/add'], .productView-buttons, .productView-form, .product-form, [name='add'], #product-add-to-cart, .productView-quantity, .quantity",
      );
    const isPay = (el) =>
      !!el.querySelector?.(".shopify-payment-button, [data-shopify='payment-button']");
    const isPrice = (el) =>
      !isFormish(el) &&
      (el.matches?.(".productView-price, .price") ||
        !!el.querySelector?.(".productView-price, .price-item, [data-product-price]")) &&
      !el.classList.contains("yb-price-vat") &&
      !el.classList.contains("yb-buybox-chrome") &&
      !el.classList.contains("yb-buybox-warranty");
    const isB2b = (el) =>
      !!(el.classList && el.classList.contains("yb-b2b-product-actions"));
    const chrome = buybox.querySelector(":scope > .yb-buybox-chrome");
    const warranty = buybox.querySelector(":scope > .yb-buybox-warranty");
    const vat = buybox.querySelector(":scope > .yb-price-vat");
    const price = kids.find((el) => el !== chrome && el !== warranty && el !== vat && isPrice(el));
    const b2b = kids.filter((el) => isB2b(el));
    const formish = kids.filter(
      (el) =>
        el !== price &&
        el !== chrome &&
        el !== warranty &&
        el !== vat &&
        !isB2b(el) &&
        isFormish(el),
    );
    const pay = kids.filter(
      (el) =>
        el !== price &&
        el !== chrome &&
        el !== warranty &&
        el !== vat &&
        !isB2b(el) &&
        !formish.includes(el) &&
        isPay(el),
    );
    const rest = kids.filter(
      (el) =>
        el !== price &&
        el !== chrome &&
        el !== warranty &&
        el !== vat &&
        !isB2b(el) &&
        !formish.includes(el) &&
        !pay.includes(el),
    );
    [price, vat, ...formish, ...pay, ...b2b, chrome, warranty, ...rest]
      .filter(Boolean)
      .forEach((el) => {
        buybox.appendChild(el);
      });
  }

  function tintBuyboxPrices(buybox) {
    if (!buybox) return;
    buybox.querySelectorAll("p, span, div, dd, dt, strong").forEach((el) => {
      if (el.closest(".yb-buybox-chrome, .yb-buybox-warranty, .yb-price-vat, .yb-b2b-product-actions"))
        return;
      const t = textOf(el);
      if (t.length > 48) return;
      if (/^(subtotal|total)?[:\s]*aed\b/i.test(t) || /^subtotal\b/i.test(t)) {
        el.style.setProperty("color", "#004A9F", "important");
      }
    });
  }

  function containBuyboxShare(buybox) {
    if (!buybox) return;
    buybox.style.setProperty("overflow", "visible", "important");
    buybox.style.setProperty("padding-right", "20px", "important");
    buybox.style.setProperty("box-sizing", "border-box", "important");

    buybox
      .querySelectorAll(
        ".productView-groupTop, .pvGroup-row, .product-form__buttons, .productView-action",
      )
      .forEach((row) => {
        row.style.setProperty("display", "flex", "important");
        row.style.setProperty("flex-wrap", "nowrap", "important");
        row.style.setProperty("align-items", "center", "important");
        row.style.setProperty("gap", "6px", "important");
        row.style.setProperty("max-width", "100%", "important");
        row.style.setProperty("min-width", "0", "important");
        row.style.setProperty("width", "100%", "important");
        row.style.setProperty("box-sizing", "border-box", "important");
        row.style.setProperty("overflow", "visible", "important");
      });
    buybox.querySelectorAll(".productView-buttons").forEach((wrap) => {
      wrap.style.setProperty("display", "block", "important");
      wrap.style.setProperty("max-width", "100%", "important");
      wrap.style.setProperty("overflow", "visible", "important");
    });
    // Keep terms / buy-it-now under the ATC row, never beside the share icon
    buybox.querySelectorAll(".productView-checkbox, .agree-terms, .productView-terms, .terms-conditions").forEach((el) => {
      el.style.setProperty("display", "block", "important");
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("max-width", "100%", "important");
      el.style.setProperty("flex", "0 0 100%", "important");
    });

    buybox
      .querySelectorAll("share-button.share-button, .share-button, .productView-share, .scoder-socialShare")
      .forEach((share) => {
        share.style.setProperty("position", "relative", "important");
        share.style.setProperty("display", "inline-flex", "important");
        share.style.setProperty("flex", "0 0 36px", "important");
        share.style.setProperty("width", "36px", "important");
        share.style.setProperty("min-width", "36px", "important");
        share.style.setProperty("max-width", "36px", "important");
        share.style.setProperty("height", "36px", "important");
        share.style.setProperty("margin", "0", "important");
        share.style.setProperty("right", "0", "important");
        share.style.setProperty("left", "auto", "important");
        share.style.setProperty("float", "none", "important");
        share.style.setProperty("overflow", "visible", "important");
        share.style.setProperty("box-sizing", "border-box", "important");

        const content = share.querySelector(".share-content");
        if (content) {
          content.style.setProperty("position", "relative", "important");
          content.style.setProperty("width", "36px", "important");
          content.style.setProperty("min-width", "36px", "important");
          content.style.setProperty("max-width", "36px", "important");
          content.style.setProperty("height", "36px", "important");
          content.style.setProperty("overflow", "visible", "important");
        }

        const btn = share.querySelector(".share-button__button, button");
        if (btn) {
          btn.style.setProperty("width", "36px", "important");
          btn.style.setProperty("height", "36px", "important");
          btn.style.setProperty("min-width", "36px", "important");
          btn.style.setProperty("padding", "0", "important");
          btn.style.setProperty("margin", "0", "important");
        }

        // Theme keeps the 300px fallback panel in normal flow (opacity:0).
        // Pull it out of flow so the circle never pushes past the column edge.
        share.querySelectorAll(".share-button__fallback").forEach((panel) => {
          panel.style.setProperty("position", "absolute", "important");
          panel.style.setProperty("top", "calc(100% + 8px)", "important");
          panel.style.setProperty("right", "0", "important");
          panel.style.setProperty("left", "auto", "important");
          panel.style.setProperty("width", "min(280px, calc(100vw - 48px))", "important");
          panel.style.setProperty("max-width", "280px", "important");
          panel.style.setProperty("z-index", "40", "important");
          panel.style.setProperty("box-sizing", "border-box", "important");
        });
      });
  }

  function retargetTermsLinks(buybox) {
    const termsUrl = storefrontTermsUrl();
    const scope = buybox || document.querySelector(".yb-pdp-buybox") || document;
    const nodes = scope.querySelectorAll("a, button, span, label");
    nodes.forEach((el) => {
      if (!/terms/i.test(textOf(el)) || textOf(el).length > 80) return;
      if (el.dataset.ybTermsBound === "1") return;
      el.dataset.ybTermsBound = "1";
      if (el.tagName === "A") {
        el.setAttribute("href", termsUrl);
        el.setAttribute("target", "_blank");
        el.setAttribute("rel", "noopener noreferrer");
      }
      el.addEventListener(
        "click",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          window.open(termsUrl, "_blank", "noopener,noreferrer");
        },
        true,
      );
    });
    document.querySelectorAll(".halo-popup, .popup-terms, #terms-conditions, .terms-modal").forEach((popup) => {
      if (popup.closest(".yb-pdp-buybox")) return;
      if (DUMMY.test(textOf(popup)) && textOf(popup).length > 80) {
        popup.setAttribute("hidden", "");
        popup.style.setProperty("display", "none", "important");
      }
    });
  }

  function refreshPdpGallery() {
    try {
      const gallery =
        document.querySelector(".yb-pdp-gallery") ||
        document.querySelector(".productView-images");
      if (gallery) {
        gallery
          .querySelectorAll(".productView-for.slick-initialized .slick-slide")
          .forEach((slide) => {
            slide.style.removeProperty("display");
            slide.style.removeProperty("width");
          });
      }
      if (window.jQuery) {
        const $ = window.jQuery;
        $(
          ".productView-nav.slick-initialized, [data-image-gallery-main].slick-initialized, .productView-for.slick-initialized, .productView-image.slick-initialized",
        ).each(function () {
          try {
            $(this).slick("setPosition");
          } catch (e) {}
        });
      }
      window.dispatchEvent(new Event("resize"));
    } catch (e) {}
  }

  function polishPdpGallery() {
    const gallery =
      document.querySelector(".yb-pdp-gallery") ||
      document.querySelector(".productView-images");
    if (!gallery) return;
    gallery.classList.add("yb-pdp-gallery-polish");

    gallery
      .querySelectorAll(
        ".productView-nav.slick-initialized .slick-slide, .productView-nav.slick-initialized .productView-image, [data-image-gallery-main].slick-initialized .slick-slide",
      )
      .forEach((slide) => {
        slide.style.removeProperty("display");
        slide.style.removeProperty("visibility");
        slide.style.removeProperty("width");
        slide.style.removeProperty("height");
        slide.style.removeProperty("overflow");
      });

    gallery.querySelectorAll(".productView-nav img, [data-image-gallery-main] img").forEach((img) => {
      img.style.setProperty("opacity", "1", "important");
      img.style.setProperty("visibility", "visible", "important");
      if (img.classList.contains("lazyload") && img.dataset.src && !img.getAttribute("src")) {
        img.setAttribute("src", img.dataset.src);
      }
      if (img.dataset.srcset && !img.getAttribute("srcset")) {
        img.setAttribute("srcset", img.dataset.srcset);
      }
    });

    gallery.querySelectorAll(".productView-thumbnail-link").forEach((link) => {
      link.classList.remove("animated-loading");
      const img = link.querySelector("img");
      if (!img) return;
      img.style.setProperty("opacity", "1", "important");
      if (img.dataset.ybThumbReady === "1") return;
      img.dataset.ybThumbReady = "1";
      const finish = () => link.classList.remove("animated-loading");
      if (img.complete) finish();
      else img.addEventListener("load", finish, { once: true });
    });

    const thumbStrip = gallery.querySelector(".productView-for.slick-initialized");

    /** Collapse duplicate media nodes by Shopify media id (never CSS-only hide of unique images). */
    dedupePdpGalleryByMediaId(gallery);

    gallery.querySelectorAll(".productView-for > .productView-thumbnail:not(.slick-slide)").forEach((el) => {
      const id = el.dataset?.mediaId || "";
      const inTrack = id
        ? thumbStrip?.querySelector(`.slick-slide[data-media-id="${CSS.escape(id)}"]:not(.slick-cloned)`)
        : null;
      if (inTrack || (id && gallery.dataset.ybThumbSeen?.split("|").includes(id))) {
        el.remove();
        return;
      }
      if (window.jQuery && thumbStrip && window.jQuery(thumbStrip).hasClass("slick-initialized")) {
        try {
          if (id) {
            const seen = (gallery.dataset.ybThumbSeen || "").split("|").filter(Boolean);
            if (!seen.includes(id)) {
              seen.push(id);
              gallery.dataset.ybThumbSeen = seen.join("|");
            }
          }
          window.jQuery(thumbStrip).slick("slickAdd", el);
        } catch (e) {
          el.style.removeProperty("display");
        }
      }
    });

    const THUMB_SIZE = 144;
    const THUMB_GAP = 8;

    gallery
      .querySelectorAll(".productView-for.slick-initialized .slick-slide:not(.slick-cloned)")
      .forEach((slide) => {
        slide.style.removeProperty("display");
        slide.style.removeProperty("visibility");
        slide.style.removeProperty("width");
        slide.style.removeProperty("height");
        slide.style.removeProperty("overflow");
        slide.removeAttribute("aria-hidden");
      });

    let slideCount = 0;
    if (thumbStrip) {
      slideCount = thumbStrip.querySelectorAll(".slick-slide:not(.slick-cloned)").length;
    }

    if (thumbStrip) {
      if (slideCount > 0 && slideCount <= 3) {
        gallery.classList.add("yb-pdp-thumbs-few", "yb-pdp-thumbs-fit");
      } else {
        gallery.classList.remove("yb-pdp-thumbs-few", "yb-pdp-thumbs-fit");
        const list = thumbStrip.querySelector(".slick-list");
        const listWidth = list ? list.clientWidth : 0;
        const needed = slideCount * THUMB_SIZE + Math.max(0, slideCount - 1) * THUMB_GAP;
        if (slideCount > 3 && needed <= listWidth) {
          gallery.classList.add("yb-pdp-thumbs-fit");
        }
      }
    }

    if (window.jQuery && thumbStrip) {
      const $ = window.jQuery;
      const $thumbs = $(".productView-for.slick-initialized");
      if ($thumbs.length) {
        try {
          const maxShow = parseInt(thumbStrip.dataset.maxThumbnailToShow || "4", 10);
          const slidesToShow =
            slideCount <= 3 ? slideCount : Math.min(slideCount, Math.max(3, maxShow));
          const prev =
            gallery.dataset.ybThumbSlidesToShow + ":" + gallery.dataset.ybThumbSlideCount;
          const next = slidesToShow + ":" + slideCount;
          if (prev !== next) {
            gallery.dataset.ybThumbSlidesToShow = String(slidesToShow);
            gallery.dataset.ybThumbSlideCount = String(slideCount);
            $thumbs.slick("slickSetOption", "slidesToShow", slidesToShow, false);
            $thumbs.slick("slickSetOption", "slidesToScroll", 1, false);
            $thumbs.slick("slickSetOption", "variableWidth", true, false);
            $thumbs.slick("slickSetOption", "infinite", false, false);
            $thumbs.slick("setPosition");
          }
          if (slideCount <= 3) {
            $thumbs.find(".slick-slide:not(.slick-cloned)").each(function () {
              this.style.setProperty("display", "block", "important");
              this.style.removeProperty("width");
              this.removeAttribute("aria-hidden");
            });
          }
        } catch (e) {}
      }
    }

    if (window.jQuery && gallery.dataset.ybGalleryBound !== "1") {
      gallery.dataset.ybGalleryBound = "1";
      const $ = window.jQuery;
      const $nav = $(".productView-nav.slick-initialized, [data-image-gallery-main].slick-initialized");
      if ($nav.length) {
        $nav.on("afterChange init reInit setPosition", function () {
          $(this)
            .find(".slick-slide, .productView-image")
            .css({ display: "", visibility: "", width: "", height: "", opacity: "" });
          $(this).find("img").css({ opacity: 1, visibility: "visible" });
          refreshPdpGallery();
        });
      }
      const $thumbs = $(".productView-for.slick-initialized");
      if ($thumbs.length) {
        $thumbs.on("afterChange init reInit setPosition", function () {
          refreshPdpGallery();
        });
      }
    }

    refreshPdpGallery();
  }

  function rescuePdpColumnContent() {
    const info =
      document.querySelector(".yb-pdp-info") || document.querySelector(".yb-pdp-main");
    const buybox = document.querySelector(".yb-pdp-buybox");
    const shell = document.querySelector(".yb-pdp-details-shell");
    if (!info || !buybox) return;

    const routeNode = (el) => {
      if (!el || info.contains(el) || buybox.contains(el)) return;
      if (el.closest(".yb-pdp-policy-park, .yb-pdp-stack")) return;
      const target = columnTarget(el);
      if (target === "policy") {
        parkPolicyBlock(el);
        return;
      }
      const wrap =
        el.closest(".yb-pdp-details-shell .productView-moreItem") ||
        (el.classList && el.classList.contains("productView-moreItem") ? el : null);
      const node = wrap && !info.contains(wrap) && !buybox.contains(wrap) ? wrap : el;
      if (target === "buy") {
        if (!buybox.contains(node)) buybox.appendChild(node);
      } else if (!info.contains(node)) {
        info.appendChild(node);
      }
    };

    if (shell) {
      shell
        .querySelectorAll(
          ".productView-moreItem, .productView-buttons, .productView-form, form[action*='/cart/add'], .shopify-payment-button, .productView-product > *",
        )
        .forEach(routeNode);
    }

    // Re-seat anything that landed in the wrong column
    Array.from(info.children).forEach((el) => {
      const t = columnTarget(el);
      if (t === "buy") buybox.appendChild(el);
      else if (t === "policy") parkPolicyBlock(el);
    });
    Array.from(buybox.children).forEach((el) => {
      if (
        el.classList.contains("yb-buybox-chrome") ||
        el.classList.contains("yb-buybox-warranty") ||
        el.classList.contains("yb-price-vat")
      ) {
        return;
      }
      const t = columnTarget(el);
      if (t === "info") info.appendChild(el);
      else if (t === "policy") parkPolicyBlock(el);
    });

    // B2B lives in the buy column (price / seller / warranty / B2B)
    document.querySelectorAll(".yb-b2b-product-actions").forEach((el) => {
      if (el.closest(".yb-b2b-basket-bar")) return;
      if (!buybox.contains(el)) buybox.appendChild(el);
    });

    try {
      ensureBuyBoxChrome(buybox);
    } catch (e) {
      /* keep buybox usable even if chrome scrape fails */
    }
    try {
      sanitizeCompareAt(buybox);
      ensureVatNote(buybox);
      orderBuyBox(buybox);
      retargetTermsLinks(buybox);
      tintBuyboxPrices(buybox);
      containBuyboxShare(buybox);
    } catch (e) {}

    placeSocialProof(info);
    hideInfoSoldBy(info);
    placeInfoDescription(info);
    annotateInfoMnemonics(info);
    moveStandaloneVariantsToInfo(info, buybox);

    document.querySelectorAll(".yb-pdp-policy-park").forEach((park) => {
      park.style.setProperty("display", "none", "important");
      park.setAttribute("hidden", "");
    });

    // Keep product details stack visible below the 3-col row
    const stack = document.querySelector(".yb-pdp-stack");
    const view = document.querySelector(".productView");
    if (stack && view) {
      if (
        stack.closest(".yb-pdp-details-shell") ||
        stack.closest(".yb-pdp-main") ||
        stack.closest(".yb-pdp-buybox")
      ) {
        const bottom =
          view.querySelector(".productView-bottom") ||
          view.querySelector(".productView-description") ||
          view;
        if (bottom && stack.parentElement !== bottom) {
          bottom.insertAdjacentElement("afterbegin", stack);
        }
      }
      stack.style.display = "";
      stack.style.visibility = "visible";
      stack.removeAttribute("hidden");
      stack.classList.remove("yb-pdp-hidden");
    }
  }

  function findInfoRowByLabel(info, pattern) {
    if (!info) return null;
    const nodes = info.querySelectorAll(
      ".productView-moreItem, .productView-info-item, li, p, tr, div",
    );
    for (const n of nodes) {
      if (n.closest(".yb-pdp-info-desc, .productView-desc, .yb-buybox-chrome")) continue;
      const strong = n.querySelector("strong, b, .productView-info-name, .label, th");
      const label = strong ? textOf(strong) : textOf(n);
      if (pattern.test(label) && textOf(n).length < 160) {
        return n.closest(".productView-moreItem, .productView-info-item, tr, li") || n;
      }
    }
    return null;
  }

  function placeSocialProof(info) {
    if (!info) return;
    const scope = document.querySelector(".productView") || document;
    const sold = Array.from(
      info.querySelectorAll(".productView-moreItem, p, div, span, li"),
    ).find((n) => /sold in last/i.test(textOf(n)) && textOf(n).length < 80);
    const viewing =
      scope.querySelector(".scoder-someone-purchase") ||
      Array.from(scope.querySelectorAll("p, div, span, li")).find(
        (n) =>
          /customers? are viewing this product/i.test(textOf(n)) && textOf(n).length < 120,
      );
    if (!sold || !viewing) return;
    const soldBlock = sold.closest(".productView-moreItem") || sold;
    const viewBlock =
      viewing.closest(".productView-moreItem, .scoder-someone-purchase") || viewing;
    if (soldBlock === viewBlock) return;
    if (soldBlock.nextElementSibling !== viewBlock) {
      soldBlock.insertAdjacentElement("afterend", viewBlock);
    }
  }

  function hideInfoSoldBy(info) {
    if (!info) return;
    // Only strip duplicate Sold-by copy from the info column. Never touch the
    // intentional buybox chrome (desktop rail + mobile native stack).
    info.querySelectorAll(".yb-sold-by-yambaba, .yambaba-seller-fulfillment, .yb-buybox-soldby").forEach((el) => {
      if (el.closest(".yb-buybox-chrome, .yb-pdp-buybox, .yb-buybox-warranty")) return;
      el.style.setProperty("display", "none", "important");
      el.setAttribute("hidden", "");
    });
    info.querySelectorAll("p, div, span, li, .productView-moreItem").forEach((el) => {
      if (el.closest(".yb-buybox-chrome, .yb-pdp-buybox, .yb-buybox-warranty, .yb-pdp-info-desc, .productView-desc, form"))
        return;
      if (el.querySelector("form, button, .price, .productView-buttons")) return;
      const t = textOf(el);
      if (/^sold by\b/i.test(t) && t.length < 90) {
        el.style.setProperty("display", "none", "important");
        el.setAttribute("hidden", "");
      }
    });
  }

  function annotateInfoMnemonics(info) {
    if (!info) return;
    const rules = [
      { test: /^warranty\b/i, icon: "shield", label: "Warranty" },
      { test: /^compatibil/i, icon: "plug", label: "Compatibility" },
      { test: /^material\b/i, icon: "layers", label: "Material" },
      { test: /^colou?r\b/i, icon: "palette", label: "Colour" },
      { test: /^size\b/i, icon: "ruler", label: "Size" },
      { test: /connectiv|bluetooth|wi-?fi|nfc/i, icon: "signal", label: "Connectivity" },
    ];
    const icons = {
      shield:
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/></svg>',
      plug:
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M8 7v4M16 7v4M7 11h10v2a5 5 0 0 1-10 0v-2zM12 18v3"/></svg>',
      layers:
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 4l8 4-8 4-8-4 8-4z"/><path d="M4 12l8 4 8-4"/></svg>',
      palette:
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="8"/><circle cx="9" cy="10" r="1.1" fill="currentColor"/><circle cx="15" cy="10" r="1.1" fill="currentColor"/><circle cx="12" cy="14.5" r="1.1" fill="currentColor"/></svg>',
      ruler:
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="8" width="16" height="8" rx="1"/><path d="M8 8v3M12 8v3M16 8v3"/></svg>',
      signal:
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 16a9 9 0 0 1 14 0"/><path d="M8.5 13.5a5 5 0 0 1 7 0"/><circle cx="12" cy="17" r="1.2" fill="currentColor"/></svg>',
    };
    let marked = false;
    info.querySelectorAll(".productView-moreItem, .productView-info-item, p, li, tr").forEach((row) => {
      if (row.querySelector(".yb-pdp-attr-icon")) return;
      const strong = row.querySelector("strong, b, .productView-info-name, .label, th");
      const label = strong ? textOf(strong) : "";
      if (!label || label.length > 40) return;
      const rule = rules.find((r) => r.test.test(label));
      if (!rule) return;
      const value = textOf(row).slice(label.length).replace(/^[:\s]+/, "");
      if (!value) return;
      const icon = document.createElement("span");
      icon.className = "yb-pdp-attr-icon";
      icon.setAttribute("aria-hidden", "true");
      icon.innerHTML = icons[rule.icon];
      const host = strong || row.firstChild;
      if (host && host.parentNode) host.parentNode.insertBefore(icon, host);
      marked = true;
    });
    if (marked) info.dataset.ybMnemonics = "1";
  }

  function moveStandaloneVariantsToInfo(info, buybox) {
    if (!info || !buybox) return;
    const desc =
      info.querySelector(".yb-pdp-info-desc, .productView-desc") ||
      findInfoRowByLabel(info, /^product type\b/i);
    Array.from(buybox.querySelectorAll(".productView-moreItem, .productView-options, .swatch")).forEach(
      (el) => {
        if (el.closest("form[action*='/cart/add']")) return;
        if (el.querySelector("[name='add'], #product-add-to-cart, .productView-buttons")) return;
        if (!isVariantPickerBlock(el)) return;
        if (desc && desc.parentElement === info) desc.insertAdjacentElement("afterend", el);
        else info.appendChild(el);
      },
    );
    info.querySelectorAll(".swatch, .productView-options").forEach((el) => {
      el.classList.add("yb-pdp-variants");
    });
  }

  /** Theme short_description truncates early; show full listing copy up to 500 chars. */
  var YB_PDP_DESC_MAX_CHARS = 500;

  function decodeHtmlEntitiesDeep(str) {
    var s = String(str || "");
    for (var i = 0; i < 6; i += 1) {
      var el = document.createElement("textarea");
      el.innerHTML = s;
      var next = el.value;
      if (next === s) break;
      s = next;
    }
    return s;
  }

  function stripDescriptionTailSections(text) {
    var t = decodeHtmlEntitiesDeep(text).replace(/\r\n/g, "\n").trim();
    if (!t) return "";
    t = t.replace(/<!--\s*yambaba-warranty-start\s*-->[\s\S]*?<!--\s*yambaba-warranty-end\s*-->/gi, "");
    t = t.replace(/<!--\s*yambaba-facts-start\s*-->[\s\S]*?<!--\s*yambaba-facts-end\s*-->/gi, "");
    var warrantyIdx = t.search(/\bWarranty\b/i);
    if (warrantyIdx > 0 && warrantyIdx > t.length * 0.35) {
      t = t.slice(0, warrantyIdx).replace(/[.\s]+$/g, "").trim();
    }
    var detailsIdx = t.search(/\bProduct details\b/i);
    if (detailsIdx > 0) {
      t = t.slice(0, detailsIdx).replace(/[.\s]+$/g, "").trim();
    }
    t = t.replace(/\bBrand:\s*[\s\S]*$/i, "").trim();
    t = t.replace(/\bSKU:\s*[\s\S]*$/i, "").trim();
    t = t.replace(/\bType:\s*[\s\S]*$/i, "").trim();
    return t.trim();
  }

  function mergeFeatureLineParts(parts) {
    if (!parts || parts.length <= 1) return parts || [];
    var starters =
      /^(ANC|ENC|Call|Music|Voice|Truly|Comfortable|Compact|Bluetooth|Wireless|Active|Fast|Long|Premium|Dual|Built|Noise-Free|IP\d|USB)/i;
    var merged = [];
    parts.forEach(function (part) {
      part = part.replace(/\.\s*$/, "").trim();
      if (!part) return;
      var supportSplit = part.match(/^Support\s+(Truly|Wireless|Compact|Comfortable|Active|Fast|Long)/i);
      if (supportSplit && merged.length) {
        merged[merged.length - 1] += " Support";
        part = part.replace(/^Support\s+/i, "").trim();
      }
      if (
        merged.length &&
        part.split(/\s+/).length <= 2 &&
        !starters.test(part)
      ) {
        merged[merged.length - 1] += " " + part;
      } else {
        merged.push(part);
      }
    });
    return merged;
  }

  function splitFeatureItems(featureBlob) {
    var blob = String(featureBlob || "").trim();
    if (!blob) return [];
    if (blob.indexOf("\n") !== -1) {
      return mergeFeatureLineParts(
        blob
          .split(/\n+/)
          .map(function (line) {
            return line.replace(/^[-•*]\s*/, "").trim();
          })
          .filter(Boolean),
      );
    }
    var phrases = [
      "Active Noise Cancellation",
      "Noise-Free Calls",
      "Voice Assistant Support",
      "Voice Assistant",
      "Call Control",
      "Music Control",
      "Truly Wireless Design",
      "Compact Charging Case",
      "Comfortable Fit",
      "Wireless Design",
      "Charging Case",
      "Fast Charging",
      "Long Battery Life",
      "Water Resistant",
      "Touch Control",
      "Built-in Microphone",
      "Bluetooth Connectivity",
      "Noise Cancellation",
    ];
    phrases.sort(function (a, b) {
      return b.length - a.length;
    });
    phrases.forEach(function (phrase) {
      var escaped = phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      blob = blob.replace(new RegExp("(?<!^)(?=" + escaped + ")", "gi"), "\n");
    });
    blob = blob.replace(/([a-z])([A-Z])/g, "$1\n$2");
    var parts = blob
      .split(/\n+/)
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
    if (parts.length <= 1) return parts;
    return mergeFeatureLineParts(parts);
  }

  function truncateDescriptionText(text, maxChars) {
    var t = String(text || "").replace(/\r\n/g, "\n").trim();
    if (!t) return "";
    if (t.length <= maxChars) return t;
    var cut = t.slice(0, maxChars);
    var lastBreak = Math.max(cut.lastIndexOf("\n"), cut.lastIndexOf(" "));
    if (lastBreak > Math.floor(maxChars * 0.6)) cut = cut.slice(0, lastBreak);
    return cut.replace(/[.,;:\s]+$/g, "") + "...";
  }

  function descriptionTextToHtml(text) {
    return String(text || "")
      .split(/\n{2,}/)
      .map(function (para) {
        var body = escapeHtml(para.trim()).replace(/\n/g, "<br>");
        return body ? "<p>" + body + "</p>" : "";
      })
      .filter(Boolean)
      .join("");
  }

  function formatPlainDescriptionText(text) {
    var t = stripDescriptionTailSections(text);
    if (!t) return "";
    if (t.length > YB_PDP_DESC_MAX_CHARS) {
      t = truncateDescriptionText(t, YB_PDP_DESC_MAX_CHARS);
    }
    var featureMatch = t.match(/^([\s\S]*?)\bFeatures:\s*\n?([\s\S]*)$/i);
    if (featureMatch) {
      var intro = featureMatch[1].trim();
      var items = splitFeatureItems(featureMatch[2].trim());
      var html = descriptionTextToHtml(intro);
      if (items.length) {
        html +=
          '<p class="yb-pdp-desc-features-title"><strong>Features:</strong></p><ul class="yb-pdp-desc-features">' +
          items
            .map(function (item) {
              return "<li>" + escapeHtml(item) + "</li>";
            })
            .join("") +
          "</ul>";
      }
      return html;
    }
    return descriptionTextToHtml(t);
  }

  function stripListingDescriptionHtml(html) {
    const raw = String(html || "").trim();
    if (!raw) return "";
    const FACT_START = "<!-- yambaba-facts-start -->";
    const FACT_END = "<!-- yambaba-facts-end -->";
    const WARRANTY_START = "<!-- yambaba-warranty-start -->";
    const WARRANTY_END = "<!-- yambaba-warranty-end -->";
    let body = raw;
    const factStart = body.indexOf(FACT_START);
    const factEnd = body.indexOf(FACT_END);
    if (factStart !== -1 && factEnd !== -1 && factEnd > factStart) {
      body = body.slice(0, factStart) + body.slice(factEnd + FACT_END.length);
    }
    const warrantyStart = body.indexOf(WARRANTY_START);
    const warrantyEnd = body.indexOf(WARRANTY_END);
    if (warrantyStart !== -1 && warrantyEnd !== -1 && warrantyEnd > warrantyStart) {
      body = body.slice(0, warrantyStart) + body.slice(warrantyEnd + WARRANTY_END.length);
    }
    const wrap = document.createElement("div");
    wrap.innerHTML = body;
    wrap
      .querySelectorAll(
        "script, style, .yb-facts, .yb-warranty, [data-yambaba-facts], [data-yb-facts], [data-yambaba-warranty], [data-yambaba-specifications]",
      )
      .forEach((n) => n.remove());
    const plain = stripDescriptionTailSections((wrap.textContent || "").replace(/\r\n/g, "\n").trim());
    if (plain && !wrap.querySelector("p, ul, ol, li, br, div")) {
      return plain;
    }
    return wrap.innerHTML.trim();
  }

  function formatFullDescriptionHtml(sourceHtml) {
    const listing = stripListingDescriptionHtml(sourceHtml);
    if (!listing) return "";
    const wrap = document.createElement("div");
    if (listing.includes("<")) wrap.innerHTML = listing;
    else wrap.textContent = listing;
    wrap
      .querySelectorAll(
        "script, style, .yb-facts, .yb-warranty, [data-yambaba-facts], [data-yb-facts], [data-yambaba-warranty]",
      )
      .forEach((n) => n.remove());
    const plain = stripDescriptionTailSections((wrap.textContent || "").replace(/\r\n/g, "\n").trim());
    if (!plain || EMPTY_COPY.test(plain) || DUMMY.test(plain)) return "";
    const needsPlainFormat =
      /\bFeatures:\s*/i.test(plain) ||
      /\bWarranty\b/i.test(plain) ||
      /\bProduct details\b/i.test(plain) ||
      /[a-z][A-Z]/.test(plain);
    if (
      !needsPlainFormat &&
      plain.length <= YB_PDP_DESC_MAX_CHARS &&
      wrap.querySelector("p, ul, ol, br, h1, h2, h3, h4, table, li")
    ) {
      return wrap.innerHTML.trim();
    }
    return formatPlainDescriptionText(plain);
  }

  function isTruncatedShortDescription(el) {
    const t = textOf(el).trim();
    if (!t) return true;
    if (/\.\.\.\s*$|…\s*$/.test(t)) return true;
    return false;
  }

  function descriptionNeedsRefresh(el) {
    if (!el) return false;
    const html = String(el.innerHTML || "");
    const t = textOf(el);
    if (/&amp;amp;/.test(html)) return true;
    if (/\bProduct details\b/i.test(t)) return true;
    if (/\bWarranty\b/i.test(t) && el.querySelector(".yb-pdp-desc-features")) return true;
    const loneFeature = el.querySelector(".yb-pdp-desc-features li:only-child");
    if (loneFeature && textOf(loneFeature).length > 100) return true;
    return false;
  }

  function placeInfoDescription(info) {
    if (!info) return;
    const sourceHtml = bestDescriptionSourceHtml();
    let fullHtml = formatFullDescriptionHtml(sourceHtml);
    if (!fullHtml && cachedPdpDescriptionHtml) {
      fullHtml = formatFullDescriptionHtml(cachedPdpDescriptionHtml);
    }
    const fullProbe = document.createElement("div");
    fullProbe.innerHTML = fullHtml;
    const fullText = textOf(fullProbe).trim();

    let desc =
      info.querySelector(".yb-pdp-info-desc") ||
      info.querySelector(
        ".productView-desc, .product-description, [data-product-description]",
      );
    const existingText = desc ? textOf(desc).trim() : "";
    const htmlDiffers =
      desc &&
      fullHtml &&
      desc.innerHTML.replace(/\s+/g, " ") !== fullHtml.replace(/\s+/g, " ");
    const shouldUseFull =
      Boolean(fullHtml) &&
      (!desc ||
        existingText.length < 20 ||
        isTruncatedShortDescription(desc) ||
        descriptionNeedsRefresh(desc) ||
        htmlDiffers ||
        (fullText && fullText.length > existingText.length + 15));

    if (shouldUseFull) {
      if (desc && desc.classList.contains("yb-pdp-info-desc")) {
        desc.innerHTML = fullHtml;
      } else {
        const wrap = document.createElement("div");
        wrap.className = "yb-pdp-info-desc productView-desc";
        wrap.innerHTML = fullHtml;
        if (desc && desc.parentElement) desc.replaceWith(wrap);
        else {
          const after =
            findInfoRowByLabel(info, /^product type\b/i) ||
            info.querySelector(".productView-title") ||
            info.querySelector("h1") ||
            info.firstElementChild;
          if (after) after.insertAdjacentElement("afterend", wrap);
          else info.appendChild(wrap);
        }
        desc = wrap;
      }
    } else if (!desc) {
      return;
    }

    desc.classList.remove("yb-pdp-hidden");
    desc.removeAttribute("hidden");
    desc.style.display = "";
    if (!desc.classList.contains("yb-pdp-info-desc")) desc.classList.add("yb-pdp-info-desc");
    const typeRow = findInfoRowByLabel(info, /^product type\b/i);
    if (typeRow && desc !== typeRow && !typeRow.contains(desc)) {
      typeRow.insertAdjacentElement("afterend", desc);
    } else if (!desc.parentElement) {
      const after =
        info.querySelector(".productView-title") ||
        info.querySelector("h1") ||
        info.firstElementChild;
      if (after) after.insertAdjacentElement("afterend", desc);
      else info.appendChild(desc);
    }
    placeSpecificationsCard(info, desc);
  }

  function placeDetailedWarranty() {
    const w = document.querySelector(".yb-pdp-warranty");
    if (!w) return;
    const aplus = document.querySelector(".yb-aplus");
    if (aplus) {
      aplus.insertAdjacentElement("beforebegin", w);
      return;
    }
    const heading = Array.from(
      document.querySelectorAll("h2, h3, .section-header, .block-title"),
    ).find((h) => /^related products$/i.test((h.textContent || "").trim()));
    const relatedSection =
      heading?.closest('[id^="shopify-section"]') ||
      heading?.closest("section") ||
      heading?.parentElement ||
      document.querySelector(
        ".related-products, .product-related, .scoder-product-block-sections",
      );
    if (relatedSection && relatedSection.parentElement) {
      relatedSection.parentElement.insertBefore(w, relatedSection);
      return;
    }
    const stack = document.querySelector(".yb-pdp-stack");
    if (stack && w.parentElement !== stack) stack.insertAdjacentElement("afterend", w);
  }

  function arrangePdpThreeColumn() {
    const isDesktop =
      window.matchMedia && window.matchMedia("(min-width: 1100px)").matches;
    const view = document.querySelector(
      ".productView.scoder-productView, .productView.layout-3, .productView",
    );
    if (!view) return;

    const row = view.querySelector(".productView-top") || view;
    const gallery = row.querySelector(".productView-images");
    const details = row.querySelector(".productView-details");
    const product =
      view.querySelector(".productView-product") ||
      details ||
      view;
    if (!gallery) return;

    // Always build gallery → info → buybox siblings (desktop grid OR mobile stack).
    // Previous mobile early-return left native theme order (title/ATC before images).
    if (!view.classList.contains("yb-pdp-colv3-ready") && product) {
      const pool = [];
      const oldMain = row.querySelector(":scope > .yb-pdp-main");
      const oldAside = row.querySelector(":scope > .yb-pdp-aside, :scope > .yb-pdp-facts");
      const oldBuy = row.querySelector(":scope > .yb-pdp-buybox");
      if (oldMain) Array.from(oldMain.children).forEach((c) => pool.push(c));
      if (oldAside && oldAside !== oldBuy) {
        Array.from(oldAside.children).forEach((c) => pool.push(c));
      }
      if (oldBuy) Array.from(oldBuy.children).forEach((c) => pool.push(c));
      if (!pool.length && product !== view && product !== gallery) {
        Array.from(product.children).forEach((c) => pool.push(c));
      }

      oldMain?.remove();
      if (oldAside && oldAside !== oldBuy) oldAside.remove();
      oldBuy?.remove();

      const info = document.createElement("div");
      info.className = "yb-pdp-main yb-pdp-info";
      info.setAttribute("data-yb-mnemonic", "pdp-info");

      const buybox = document.createElement("div");
      buybox.className = "yb-pdp-buybox";
      buybox.setAttribute("data-yb-mnemonic", "pdp-buybox");

      pool.forEach((child) => {
        if (child === gallery || child === details) return;
        const target = columnTarget(child);
        if (target === "policy") parkPolicyBlock(child);
        else if (target === "buy") buybox.appendChild(child);
        else info.appendChild(child);
      });

      gallery.classList.add("yb-pdp-gallery");
      gallery.setAttribute("data-yb-mnemonic", "pdp-gallery");
      // Physical DOM order: gallery, info, buybox (do not rely on CSS order alone).
      row.insertBefore(gallery, row.firstElementChild);
      gallery.insertAdjacentElement("afterend", info);
      info.insertAdjacentElement("afterend", buybox);
      if (details) {
        details.classList.add("yb-pdp-details-shell");
        // Keep empty shell after buybox; never before gallery.
        buybox.insertAdjacentElement("afterend", details);
      }

      row.classList.add("yb-pdp-3col-row");
      view.classList.add("yb-pdp-3col", "yb-pdp-3col-ready", "yb-pdp-colv3-ready");
    }

    enforceGalleryFirstDom(row);

    const buyHost =
      row.querySelector(":scope > .yb-pdp-buybox") ||
      view.querySelector(".yb-pdp-buybox") ||
      view.querySelector(".productView-product") ||
      details ||
      view;
    const infoHost =
      row.querySelector(":scope > .yb-pdp-info") ||
      view.querySelector(".yb-pdp-info") ||
      buyHost;

    try {
      sanitizeCompareAt(buyHost);
      ensureVatNote(buyHost);
      retargetTermsLinks(buyHost);
      ensureBuyBoxChrome(buyHost);
      orderBuyBox(buyHost);
      tintBuyboxPrices(buyHost);
    } catch (e) {}
    placeSocialProof(infoHost);
    hideInfoSoldBy(infoHost);
    placeInfoDescription(infoHost);
    annotateInfoMnemonics(infoHost);

    if (isDesktop) {
      rescuePdpColumnContent();
    }
    polishPdpGallery();
    try {
      window.dispatchEvent(new CustomEvent("yb:pdp-3col-ready"));
    } catch (e) {}
  }

  /** Physical sibling order under .productView-top — gallery must be first. */
  function enforceGalleryFirstDom(row) {
    if (!row) return;
    const gallery = row.querySelector(
      ":scope > .productView-images, :scope > .yb-pdp-gallery",
    );
    const info = row.querySelector(":scope > .yb-pdp-info, :scope > .yb-pdp-main");
    const buybox = row.querySelector(":scope > .yb-pdp-buybox");
    if (!gallery) return;

    // Clear any prior inline order so desktop grid is not poisoned.
    gallery.style.removeProperty("order");
    if (info) info.style.removeProperty("order");
    if (buybox) buybox.style.removeProperty("order");

    row.insertBefore(gallery, row.firstElementChild);
    if (info) gallery.insertAdjacentElement("afterend", info);
    if (buybox && info) info.insertAdjacentElement("afterend", buybox);
    else if (buybox) gallery.insertAdjacentElement("afterend", buybox);

    // Mobile/tablet: reinforce flex stack with inline styles (beats theme floats).
    const narrow =
      !window.matchMedia || !window.matchMedia("(min-width: 1100px)").matches;
    if (narrow) {
      row.style.setProperty("display", "flex", "important");
      row.style.setProperty("flex-direction", "column", "important");
      row.style.setProperty("width", "100%", "important");
      gallery.style.setProperty("order", "1", "important");
      gallery.style.setProperty("width", "100%", "important");
      gallery.style.setProperty("max-width", "100%", "important");
      gallery.style.setProperty("float", "none", "important");
      if (info) {
        info.style.setProperty("order", "2", "important");
        info.style.setProperty("width", "100%", "important");
        info.style.setProperty("float", "none", "important");
      }
      if (buybox) {
        buybox.style.setProperty("order", "3", "important");
        buybox.style.setProperty("width", "100%", "important");
        buybox.style.setProperty("float", "none", "important");
        buybox.style.setProperty("position", "static", "important");
      }
    } else {
      row.style.removeProperty("display");
      row.style.removeProperty("flex-direction");
      row.style.removeProperty("width");
      gallery.style.removeProperty("width");
      gallery.style.removeProperty("max-width");
      gallery.style.removeProperty("float");
      if (info) {
        info.style.removeProperty("width");
        info.style.removeProperty("float");
      }
      if (buybox) {
        buybox.style.removeProperty("width");
        buybox.style.removeProperty("float");
        buybox.style.removeProperty("position");
      }
    }
  }

  // Expose for recovery if an older duplicate script loaded first
  window.__ybArrangePdpThreeColumn = arrangePdpThreeColumn;
  window.__ybEnforceGalleryFirstDom = enforceGalleryFirstDom;

  function run() {
    capturePdpDescriptionFromPage();
    hideFalseFulfillmentClaims();
    compactProductLoadingSpinner();
    captureSpecsFromDom();
    arrangePdpThreeColumn();
    watchSpecificationsCard();
    if (stackIsPlaced()) {
      hideNativeDuplicates();
      renderPrincipalSellerBadge();
      placeAplusContent();
      placeDetailedWarranty();
      return;
    }
    const misplaced = document.querySelector(".yb-pdp-stack");
    if (misplaced) misplaced.remove();

    const host = findHost();
    const sourceHtml = collectSourceHtml();
    const facts = scrapeFacts();
    const stack = buildStack(facts, sourceHtml);
    if (!host) {
      const desc = document.querySelector(
        ".product-description, .product-single__description, .rte",
      );
      if (!desc) return;
      desc.insertAdjacentHTML("afterend", stack);
      hideNativeDuplicates();
      placeAplusContent();
      placeDetailedWarranty();
      arrangePdpThreeColumn();
      return;
    }
    host.classList.add("yb-pdp-host");
    host.innerHTML = stack;
    hideNativeDuplicates();
    hideFalseFulfillmentClaims();
    compactProductLoadingSpinner();
    renderPrincipalSellerBadge();
    placeAplusContent();
    placeDetailedWarranty();
    arrangePdpThreeColumn();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", capturePdpDescriptionFromPage);
  } else {
    capturePdpDescriptionFromPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  setTimeout(capturePdpDescriptionFromPage, 0);
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 2400);
  setTimeout(polishPdpGallery, 600);
  setTimeout(polishPdpGallery, 1800);
  setTimeout(polishPdpGallery, 4000);

  // Re-assert gallery-first when rotating phone / resizing across 1100px.
  let ybResizeTimer = 0;
  window.addEventListener(
    "resize",
    () => {
      window.clearTimeout(ybResizeTimer);
      ybResizeTimer = window.setTimeout(() => {
        const row = document.querySelector(".productView-top.yb-pdp-3col-row, .productView-top");
        if (row && typeof window.__ybEnforceGalleryFirstDom === "function") {
          window.__ybEnforceGalleryFirstDom(row);
        } else {
          arrangePdpThreeColumn();
        }
      }, 150);
    },
    { passive: true },
  );

  /**
   * Dedupe PDP gallery slides/thumbs by Shopify media id (and URL basename fallback).
   * Removes duplicate DOM nodes — does not CSS-hide unique variant images.
   */
  function dedupePdpGalleryByMediaId(gallery) {
    if (!gallery) return;
    const normalizeId = (raw) => {
      const s = String(raw || "").trim();
      if (!s) return "";
      const m = s.match(/(\d{8,})$/);
      return m ? m[1] : s;
    };
    const basename = (url) => {
      try {
        const u = String(url || "").split("?")[0];
        const parts = u.split("/");
        return parts[parts.length - 1] || "";
      } catch (e) {
        return "";
      }
    };

    const dedupeList = (nodes) => {
      const seenIds = new Set();
      const seenUrls = new Set();
      for (let i = 0; i < nodes.length && i < 200; i += 1) {
        const el = nodes[i];
        if (el.classList?.contains("slick-cloned")) continue;
        const id = normalizeId(el.getAttribute("data-media-id") || el.dataset?.mediaId);
        const img = el.querySelector?.("img") || (el.tagName === "IMG" ? el : null);
        const urlKey = basename(
          img?.getAttribute("src") ||
            img?.getAttribute("data-src") ||
            img?.getAttribute("srcset") ||
            el.querySelector?.("[data-image]")?.getAttribute("data-image") ||
            "",
        );
        const idDup = id && seenIds.has(id);
        const urlDup = !id && urlKey && seenUrls.has(urlKey);
        if (idDup || urlDup) {
          el.remove();
          continue;
        }
        if (id) seenIds.add(id);
        if (urlKey) seenUrls.add(urlKey);
      }
    };

    dedupeList(
      Array.from(
        gallery.querySelectorAll(
          ".productView-nav > .productView-image, .productView-nav .slick-slide:not(.slick-cloned)",
        ),
      ),
    );
    dedupeList(
      Array.from(
        gallery.querySelectorAll(
          ".productView-for > .productView-thumbnail, .productView-for .slick-slide:not(.slick-cloned)",
        ),
      ),
    );
    // Orphan thumbs left outside the slick track (duplicate copies).
    gallery
      .querySelectorAll(".productView-for .productView-thumbnail:not(.slick-slide)")
      .forEach((el) => {
        const raw = el.getAttribute("data-media-id") || "";
        const id = normalizeId(raw);
        if (!id) return;
        const inSlick = gallery.querySelector(
          `.productView-for .slick-slide:not(.slick-cloned)[data-media-id$="${id}"]`,
        );
        if (inSlick) el.remove();
      });
  }

  /**
   * When a color swatch is chosen, switch main gallery to that variant's media.
   * Prefer featured_media / media.id; Color option by name (not Size at option-index 1).
   * Fallback: alt text match → keep current / product featured (no blank image).
   */
  function setupColorGallerySwitch() {
    const root = document.querySelector(".productView") || document.body;
    if (!root || root.dataset.ybColorGallery === "1") return;
    root.dataset.ybColorGallery = "1";

    function isColorOptionName(name) {
      return /^colou?r$/i.test(String(name || "").trim());
    }

    function readSelectedColor() {
      const named = root.querySelector(
        '.swatch[data-option-name*="olor" i] .swatch-element.is-active, fieldset[name*="olor" i] .swatch-element.is-active',
      );
      if (named) {
        const v =
          named.getAttribute("data-value") ||
          named.getAttribute("data-swatch") ||
          named.querySelector("label")?.getAttribute("title") ||
          named.querySelector("label")?.getAttribute("data-value") ||
          named.querySelector("input:checked")?.value;
        if (v) return String(v).trim();
      }

      const swatches = Array.from(root.querySelectorAll(".swatch[data-option-index], .swatch"));
      for (let i = 0; i < swatches.length && i < 12; i += 1) {
        const sw = swatches[i];
        const label =
          sw.getAttribute("data-option-name") ||
          sw.querySelector(".form-label, .label, legend, .swatch-title")?.textContent ||
          "";
        if (!isColorOptionName(label) && !/olor/i.test(label)) continue;
        const active =
          sw.querySelector(".swatch-element.is-active") ||
          sw.querySelector("input:checked")?.closest(".swatch-element");
        if (!active) continue;
        const v =
          active.getAttribute("data-value") ||
          active.getAttribute("data-swatch") ||
          active.querySelector("label")?.getAttribute("title") ||
          active.querySelector("input")?.value;
        if (v) return String(v).trim();
      }

      const checked = root.querySelector(
        '[name*="olor" i]:checked, fieldset[name*="olor" i] input:checked',
      );
      if (checked) {
        return String(
          checked.getAttribute("value") || checked.getAttribute("data-value") || "",
        ).trim();
      }
      return "";
    }

    function currentVariantFeaturedMediaId() {
      try {
        const form =
          root.querySelector('form[action*="/cart/add"], .product-form, product-form') ||
          document.querySelector('form[action*="/cart/add"]');
        const idInput = form?.querySelector('[name="id"]');
        const variantId = idInput?.value;
        if (!variantId) return "";

        // Prefer in-page variant JSON (theme embeds featured_media after Shopify assign).
        const scripts = Array.from(
          document.querySelectorAll("script[type='application/json'], script:not([src])"),
        );
        for (let i = 0; i < scripts.length && i < 40; i += 1) {
          const txt = scripts[i].textContent || "";
          if (!txt.includes("featured_media") || txt.length > 500000) continue;
          try {
            const data = JSON.parse(txt);
            const variants = Array.isArray(data)
              ? data
              : data.variants || data.product?.variants || [];
            if (!Array.isArray(variants)) continue;
            const v = variants.find(
              (x) =>
                String(x.id) === String(variantId) ||
                String(x.id).endsWith(String(variantId)),
            );
            const fm = v?.featured_media || v?.featuredMedia;
            if (fm?.id) return String(fm.id);
            if (v?.image_id) return String(v.image_id);
            if (v?.featured_image?.id) return String(v.featured_image.id);
          } catch (e) {}
        }
      } catch (e) {}
      return "";
    }

    function clickMediaById(mediaId) {
      if (!mediaId) return false;
      const id = String(mediaId);
      const endsWithId = (mid) => {
        const m = String(mid || "");
        return m === id || m.endsWith("-" + id) || m.endsWith(id);
      };

      // Prefer main gallery slickGoTo by media id (theme updateMedia selector can mismatch section vs product id).
      if (window.jQuery) {
        const $nav = window.jQuery(
          ".productView-nav.slick-initialized, [data-image-gallery-main].slick-initialized",
        );
        if ($nav.length) {
          const slides = $nav.find(".slick-slide:not(.slick-cloned) [data-media-id], .slick-slide:not(.slick-cloned)");
          for (let i = 0; i < slides.length && i < 80; i += 1) {
            const el = slides[i];
            const mid =
              el.getAttribute("data-media-id") ||
              el.querySelector?.("[data-media-id]")?.getAttribute("data-media-id") ||
              "";
            if (!endsWithId(mid)) continue;
            const slide = el.closest(".slick-slide") || el;
            const idx = window.jQuery(slide).data("slick-index");
            if (typeof idx === "number") {
              try {
                $nav.slick("slickGoTo", idx, true);
                return true;
              } catch (e) {}
            }
          }
        }
      }

      const candidates = root.querySelectorAll(
        `[data-media-id="${CSS.escape(id)}"], [data-media-id$="-${CSS.escape(id)}"], .productView-thumbnail[data-media-id*="${CSS.escape(id)}"]`,
      );
      for (let i = 0; i < candidates.length && i < 40; i += 1) {
        const el = candidates[i];
        if (el.classList?.contains("slick-cloned")) continue;
        const clickable =
          el.querySelector?.(".productView-thumbnail-link, img, [data-main-image]") || el;
        if (typeof clickable.click === "function") {
          clickable.click();
          return true;
        }
      }
      return false;
    }

    function applyColor(color) {
      const mediaId = currentVariantFeaturedMediaId();
      if (mediaId && clickMediaById(mediaId)) return;

      const colorLc = String(color || "").trim().toLowerCase();
      if (!colorLc) return;

      const thumbs = Array.from(
        root.querySelectorAll(
          ".productView-thumbnail:not(.slick-cloned), .productView-nav .slick-slide:not(.slick-cloned), .productView-nav > .productView-image",
        ),
      );
      for (let i = 0; i < thumbs.length && i < 80; i += 1) {
        const t = thumbs[i];
        const img = t.querySelector?.("img") || (t.tagName === "IMG" ? t : null);
        const alt = String(
          img?.getAttribute("alt") ||
            t.getAttribute("data-alt") ||
            t.getAttribute("aria-label") ||
            "",
        )
          .trim()
          .toLowerCase();
        if (alt !== colorLc) continue;
        const link = t.querySelector?.(".productView-thumbnail-link") || t;
        if (typeof link.click === "function") link.click();
        else if (img && typeof img.click === "function") img.click();
        return;
      }
      // Fallback: keep currently selected / product featured — never blank the main image.
    }

    const onMaybeColorChange = () => {
      window.setTimeout(() => applyColor(readSelectedColor()), 80);
    };
    root.addEventListener("change", onMaybeColorChange, true);
    root.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest(".swatch, .swatch-element, .swatch-view, [data-option-index]")) {
        onMaybeColorChange();
      }
    });
    document.addEventListener("variant:change", onMaybeColorChange);
    document.addEventListener("variantChange", onMaybeColorChange);
  }

  setupColorGallerySwitch();
  setTimeout(setupColorGallerySwitch, 800);
  setTimeout(setupColorGallerySwitch, 2000);

  function installPdpReturnDisclosure() {
    if (document.getElementById("yb-pdp-com-disclosure")) return;
    const buybox =
      document.querySelector(".yb-pdp-buybox") ||
      document.querySelector(".productView-product") ||
      document.querySelector("form[action*='/cart/add']");
    if (!buybox) return;
    const anchor =
      buybox.querySelector(".productView-buttons, .product-form__buttons, .productView-action, .shopify-payment-button") ||
      buybox;
    const el = document.createElement("aside");
    el.id = "yb-pdp-com-disclosure";
    el.setAttribute("aria-label", "Returns disclosure");
    el.style.cssText =
      "margin:10px 0 12px;padding:10px 12px;border:1px solid #d7e0ea;border-radius:8px;" +
      "background:#f7fafc;font-size:12.5px;line-height:1.45;color:#0b1f3a;max-width:100%";
    el.innerHTML =
      "<strong>Returns at a glance</strong>" +
      "<ul style='margin:6px 0 0;padding-left:16px'>" +
      "<li><strong>Seller-fault</strong> (wrong, faulty, damaged, not as described): eligible merchandise and original shipping refund after approval — you are not charged for seller-fault return logistics.</li>" +
      "<li><strong>Change of mind</strong> (5 days from receipt): return the item to the YamBaba Fulfilment Centre. Original delivery you paid is not refunded. If delivery was free or subsidised, an applicable outbound delivery recovery may apply — exact amount shown before you confirm a return.</li>" +
      "<li>Final refund remains subject to return inspection.</li>" +
      "</ul>" +
      '<p style="margin:8px 0 0"><a href="/policies/refund-policy" target="_blank" rel="noopener">Learn more</a> · ' +
      '<a href="https://portal.yambaba.ae/returns/customer" target="_blank" rel="noopener">Start a return</a></p>';
    if (anchor.parentNode === buybox) {
      buybox.insertBefore(el, anchor);
    } else {
      buybox.appendChild(el);
    }
  }
  [0, 100, 400, 1200].forEach((ms) => setTimeout(installPdpReturnDisclosure, ms));

  [8000, 20000, 45000, 90000, 180000].forEach((ms) => {
    setTimeout(() => {
      const info =
        document.querySelector(".yb-pdp-info") ||
        document.querySelector(".productView-product") ||
        document.querySelector(".productView-details");
      if (!info) return;
      placeSpecificationsCard(
        info,
        info.querySelector(".yb-pdp-info-desc, .productView-desc"),
      );
    }, ms);
  });

  /** Require an explicit Color/Size (etc.) choice before Add to cart / Buy now. */
  function installVariantSelectGuard() {
    if (document.documentElement.dataset.ybVariantGuard === "1") return;
    document.documentElement.dataset.ybVariantGuard = "1";

    function optionGroups() {
      const root =
        document.querySelector(".productView, .yb-pdp-info, .yb-pdp-buybox") ||
        document;
      const groups = [];
      const fieldsets = root.querySelectorAll(
        ".productView-options .form-field, .product-form__input, fieldset, .swatch, [data-option-index], .variant-input-wrap",
      );
      fieldsets.forEach((fs) => {
        if (groups.length >= 12) return;
        const legend =
          fs.querySelector("legend, .form-label, .option-label, label") || null;
        let name = (legend?.textContent || fs.getAttribute("data-option-name") || "")
          .replace(/\s+/g, " ")
          .trim();
        name = name.replace(/:\s*$/, "").replace(/selected.*/i, "").trim();
        const inputs = Array.from(
          fs.querySelectorAll(
            'input[type="radio"], input[type="checkbox"], select, .swatch-element input, [data-value]',
          ),
        );
        const swatches = Array.from(
          fs.querySelectorAll(
            ".swatch-element, .swatch-view-item, [data-value].swatch, button[data-value], label[data-value]",
          ),
        );
        if (!inputs.length && !swatches.length && !fs.matches("select")) return;
        // Skip pure quantity blocks
        if (/quantity/i.test(name)) return;
        groups.push({ el: fs, name: name || "option", inputs, swatches });
      });
      // Also catch bare option selects
      root.querySelectorAll('select[name^="options"], select[id*="Option"]').forEach((sel) => {
        if (groups.some((g) => g.el === sel || g.el.contains(sel))) return;
        const label = sel.closest(".form-field")?.querySelector("label, .form-label");
        groups.push({
          el: sel,
          name: (label?.textContent || sel.getAttribute("name") || "option")
            .replace(/\s+/g, " ")
            .trim(),
          inputs: [sel],
          swatches: [],
        });
      });
      return groups;
    }

    function groupSelected(g) {
      if (g.el.tagName === "SELECT") {
        const v = g.el.value;
        return !!(v && v !== "" && !/^default title$/i.test(v));
      }
      for (let i = 0; i < g.inputs.length; i += 1) {
        const inp = g.inputs[i];
        if (inp.tagName === "SELECT") {
          const v = inp.value;
          if (v && v !== "" && !/^default title$/i.test(v)) return true;
          continue;
        }
        if (inp.checked) {
          const v = inp.value || inp.getAttribute("data-value") || "";
          if (v && !/^default title$/i.test(v)) return true;
        }
      }
      for (let i = 0; i < g.swatches.length; i += 1) {
        const s = g.swatches[i];
        if (
          s.classList.contains("is-active") ||
          s.classList.contains("active") ||
          s.classList.contains("selected") ||
          s.getAttribute("aria-checked") === "true" ||
          s.querySelector?.("input:checked")
        ) {
          return true;
        }
      }
      return false;
    }

    function missingOptions() {
      const groups = optionGroups();
      // Only enforce when there is at least one real choosable option group
      // and product has >1 sellable variant (or visible multi options).
      const metaVariants = window.meta?.product?.variants || [];
      const multiVariant = metaVariants.length > 1;
      const multiGroups = groups.length > 0;
      if (!multiVariant && !multiGroups) return [];
      // Single-variant products: never block
      if (metaVariants.length <= 1 && groups.length === 0) return [];
      if (metaVariants.length <= 1) {
        // Theme may still render a Title/Default option UI — ignore those
        const real = groups.filter((g) => !/^title$/i.test(g.name));
        if (!real.length) return [];
      }
      const missing = [];
      const useGroups =
        metaVariants.length <= 1
          ? groups.filter((g) => !/^title$/i.test(g.name))
          : groups.filter((g) => !/^title$/i.test(g.name) || groups.length === 1);
      for (let i = 0; i < useGroups.length && i < 8; i += 1) {
        const g = useGroups[i];
        if (!groupSelected(g)) missing.push(g);
      }
      return missing;
    }

    function showPrompt(missing) {
      document.querySelectorAll(".yb-variant-select-prompt").forEach((el) => el.remove());
      const names = missing
        .map((g) => g.name || "option")
        .filter(Boolean)
        .slice(0, 3);
      const label =
        names.length === 1
          ? "Please select a " + names[0] + " before adding to cart."
          : "Please select: " + names.join(", ") + " before adding to cart.";
      const first = missing[0]?.el;
      const host =
        first?.closest?.(".productView-options, .yb-pdp-info, .yb-pdp-buybox, .productView-product") ||
        document.querySelector(".productView-options") ||
        document.querySelector(".yb-pdp-info") ||
        document.querySelector(".yb-pdp-buybox");
      if (!host) {
        window.alert(label);
        return;
      }
      const banner = document.createElement("div");
      banner.className = "yb-variant-select-prompt";
      banner.setAttribute("role", "alert");
      banner.textContent = label;
      host.insertBefore(banner, host.firstChild);
      try {
        first?.scrollIntoView?.({ behavior: "smooth", block: "center" });
      } catch (e) {}
      try {
        host.classList.add("yb-variant-needed");
        window.setTimeout(() => host.classList.remove("yb-variant-needed"), 1600);
      } catch (e) {}
    }

    function clearPromptIfReady() {
      if (!missingOptions().length) {
        document.querySelectorAll(".yb-variant-select-prompt").forEach((el) => el.remove());
      }
    }

    document.addEventListener(
      "click",
      (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        const btn = t.closest(
          'button[name="add"], #product-add-to-cart, .product-form__submit, .shopify-payment-button__button, [data-addtocart], .productView-action button[type="submit"]',
        );
        if (!btn) return;
        if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
        const missing = missingOptions();
        if (!missing.length) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        showPrompt(missing);
      },
      true,
    );

    document.addEventListener("change", clearPromptIfReady, true);
    document.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest(".swatch, .swatch-element, [data-option-index], .productView-options")) {
        window.setTimeout(clearPromptIfReady, 50);
      }
    });
  }

  installVariantSelectGuard();
  setTimeout(installVariantSelectGuard, 600);
})();
